!(function (t, d) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = d())
    : 'function' == typeof define && define.amd
    ? define('libphonenumber', [], d)
    : 'object' == typeof exports
    ? (exports.libphonenumber = d())
    : (t.libphonenumber = d());
})(window, function () {
  return (function (t) {
    var d = {};
    function e(r) {
      if (d[r]) return d[r].exports;
      var n = (d[r] = { i: r, l: !1, exports: {} });
      return t[r].call(n.exports, n, n.exports, e), (n.l = !0), n.exports;
    }
    return (
      (e.m = t),
      (e.c = d),
      (e.d = function (t, d, r) {
        e.o(t, d) || Object.defineProperty(t, d, { configurable: !1, enumerable: !0, get: r });
      }),
      (e.r = function (t) {
        Object.defineProperty(t, '__esModule', { value: !0 });
      }),
      (e.n = function (t) {
        var d =
          t && t.__esModule
            ? function () {
                return t.default;
              }
            : function () {
                return t;
              };
        return e.d(d, 'a', d), d;
      }),
      (e.o = function (t, d) {
        return Object.prototype.hasOwnProperty.call(t, d);
      }),
      (e.p = ''),
      e((e.s = 29))
    );
  })([
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.DIGITS =
          d.MAX_LENGTH_COUNTRY_CODE =
          d.MAX_LENGTH_FOR_NSN =
          d.PLUS_CHARS =
          d.VALID_PUNCTUATION =
          d.VALID_DIGITS =
          d.WHITESPACE =
            void 0),
        (d.parseDigit = function (t) {
          return l[t];
        }),
        (d.extractCountryCallingCode = function (t, d, e) {
          if (!(t = (0, $.default)(t))) return {};
          if ('+' !== t[0]) {
            var a = (0, r.stripIDDPrefix)(t, d, e);
            if (!a || a === t) return { number: t };
            t = '+' + a;
          }
          if ('0' === t[1]) return {};
          e = new n.default(e);
          var i = 2;
          for (; i - 1 <= s && i <= t.length; ) {
            var o = t.slice(1, i);
            if (e.countryCallingCodes()[o]) return { countryCallingCode: o, number: t.slice(i) };
            i++;
          }
          return {};
        }),
        (d.matches_entirely = function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '',
            d = arguments[1];
          return new RegExp('^(?:' + d + ')$').test(t);
        }),
        (d.create_extension_pattern = function (t) {
          var d = 'xｘ#＃~～';
          switch (t) {
            case 'parsing':
              d = ',;' + d;
          }
          return (
            f +
            c +
            '|[  \\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|[' +
            d +
            ']|int|anexo|ｉｎｔ)[:\\.．]?[  \\t,-]*' +
            c +
            '#?|[- ]+([' +
            o +
            ']{1,5})#'
          );
        });
      var r = e(19),
        n = a(e(1)),
        $ = a(e(8));
      function a(t) {
        return t && t.__esModule ? t : { default: t };
      }
      var i = (d.WHITESPACE = '  ­​⁠　'),
        o = (d.VALID_DIGITS = '0-9０-９٠-٩۰-۹'),
        u =
          ((d.VALID_PUNCTUATION = '-‐-―−ー－／/．.' + i + '()（）［］\\[\\]~⁓∼～'),
          (d.PLUS_CHARS = '+＋')),
        s =
          (new RegExp('^[' + u + ']+'),
          (d.MAX_LENGTH_FOR_NSN = 17),
          (d.MAX_LENGTH_COUNTRY_CODE = 3)),
        l = (d.DIGITS = {
          0: '0',
          1: '1',
          2: '2',
          3: '3',
          4: '4',
          5: '5',
          6: '6',
          7: '7',
          8: '8',
          9: '9',
          '０': '0',
          '１': '1',
          '２': '2',
          '３': '3',
          '４': '4',
          '５': '5',
          '６': '6',
          '７': '7',
          '８': '8',
          '９': '9',
          '٠': '0',
          '١': '1',
          '٢': '2',
          '٣': '3',
          '٤': '4',
          '٥': '5',
          '٦': '6',
          '٧': '7',
          '٨': '8',
          '٩': '9',
          '۰': '0',
          '۱': '1',
          '۲': '2',
          '۳': '3',
          '۴': '4',
          '۵': '5',
          '۶': '6',
          '۷': '7',
          '۸': '8',
          '۹': '9',
        });
      var f = ';ext=',
        c = '([' + o + ']{1,7})';
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 });
      var r =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                'function' == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            };
      (d.validateMetadata = y),
        (d.getExtPrefix = function (t, d) {
          return new l(d).country(t).ext();
        });
      var n,
        $ = e(28),
        a = (n = $) && n.__esModule ? n : { default: n };
      var i =
          'function' == typeof Symbol && 'symbol' === r(Symbol.iterator)
            ? function (t) {
                return void 0 === t ? 'undefined' : r(t);
              }
            : function (t) {
                return t &&
                  'function' == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? 'symbol'
                  : void 0 === t
                  ? 'undefined'
                  : r(t);
              },
        o = (function () {
          function t(t, d) {
            for (var e = 0; e < d.length; e++) {
              var r = d[e];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                'value' in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (d, e, r) {
            return e && t(d.prototype, e), r && t(d, r), d;
          };
        })();
      function u(t, d) {
        if (!(t instanceof d)) throw new TypeError('Cannot call a class as a function');
      }
      var s = '1.2.0',
        l = (function () {
          function t(d) {
            u(this, t),
              y(d),
              (this.metadata = d),
              (this.v1 = !d.version),
              (this.v2 = void 0 !== d.version && -1 === (0, a.default)(d.version, s)),
              (this.v3 = void 0 !== d.version);
          }
          return (
            o(t, [
              {
                key: 'hasCountry',
                value: function (t) {
                  return void 0 !== this.metadata.countries[t];
                },
              },
              {
                key: 'country',
                value: function (t) {
                  if (!t) return (this._country = void 0), (this.country_metadata = void 0), this;
                  if (!this.hasCountry(t)) throw new Error('Unknown country: ' + t);
                  return (
                    (this._country = t), (this.country_metadata = this.metadata.countries[t]), this
                  );
                },
              },
              {
                key: 'getDefaultCountryMetadataForRegion',
                value: function () {
                  return this.metadata.countries[
                    this.countryCallingCodes()[this.countryCallingCode()][0]
                  ];
                },
              },
              {
                key: 'countryCallingCode',
                value: function () {
                  return this.country_metadata[0];
                },
              },
              {
                key: 'IDDPrefix',
                value: function () {
                  if (!this.v1 && !this.v2) return this.country_metadata[1];
                },
              },
              {
                key: 'defaultIDDPrefix',
                value: function () {
                  if (!this.v1 && !this.v2) return this.country_metadata[12];
                },
              },
              {
                key: 'nationalNumberPattern',
                value: function () {
                  return this.v1 || this.v2 ? this.country_metadata[1] : this.country_metadata[2];
                },
              },
              {
                key: 'possibleLengths',
                value: function () {
                  if (!this.v1) return this.country_metadata[this.v2 ? 2 : 3];
                },
              },
              {
                key: '_getFormats',
                value: function (t) {
                  return t[this.v1 ? 2 : this.v2 ? 3 : 4];
                },
              },
              {
                key: 'formats',
                value: function () {
                  var t = this,
                    d =
                      this._getFormats(this.country_metadata) ||
                      this._getFormats(this.getDefaultCountryMetadataForRegion()) ||
                      [];
                  return d.map(function (d) {
                    return new f(d, t);
                  });
                },
              },
              {
                key: 'nationalPrefix',
                value: function () {
                  return this.country_metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
                },
              },
              {
                key: '_getNationalPrefixFormattingRule',
                value: function (t) {
                  return t[this.v1 ? 4 : this.v2 ? 5 : 6];
                },
              },
              {
                key: 'nationalPrefixFormattingRule',
                value: function () {
                  return (
                    this._getNationalPrefixFormattingRule(this.country_metadata) ||
                    this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion())
                  );
                },
              },
              {
                key: 'nationalPrefixForParsing',
                value: function () {
                  return (
                    this.country_metadata[this.v1 ? 5 : this.v2 ? 6 : 7] || this.nationalPrefix()
                  );
                },
              },
              {
                key: 'nationalPrefixTransformRule',
                value: function () {
                  return this.country_metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
                },
              },
              {
                key: '_getNationalPrefixIsOptionalWhenFormatting',
                value: function () {
                  return !!this.country_metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
                },
              },
              {
                key: 'nationalPrefixIsOptionalWhenFormatting',
                value: function () {
                  return (
                    this._getNationalPrefixIsOptionalWhenFormatting(this.country_metadata) ||
                    this._getNationalPrefixIsOptionalWhenFormatting(
                      this.getDefaultCountryMetadataForRegion(),
                    )
                  );
                },
              },
              {
                key: 'leadingDigits',
                value: function () {
                  return this.country_metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
                },
              },
              {
                key: 'types',
                value: function () {
                  return this.country_metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
                },
              },
              {
                key: 'hasTypes',
                value: function () {
                  return (!this.types() || 0 !== this.types().length) && !!this.types();
                },
              },
              {
                key: 'type',
                value: function (t) {
                  if (this.hasTypes() && h(this.types(), t)) return new c(h(this.types(), t), this);
                },
              },
              {
                key: 'ext',
                value: function () {
                  return this.v1 || this.v2 ? ' ext. ' : this.country_metadata[13] || ' ext. ';
                },
              },
              {
                key: 'countryCallingCodes',
                value: function () {
                  return this.v1
                    ? this.metadata.country_phone_code_to_countries
                    : this.metadata.country_calling_codes;
                },
              },
              {
                key: 'chooseCountryByCountryCallingCode',
                value: function (t) {
                  var d = this.countryCallingCodes()[t][0];
                  this.hasCountry(d) && this.country(d);
                },
              },
              {
                key: 'selectedCountry',
                value: function () {
                  return this._country;
                },
              },
            ]),
            t
          );
        })();
      d.default = l;
      var f = (function () {
          function t(d, e) {
            u(this, t), (this._format = d), (this.metadata = e);
          }
          return (
            o(t, [
              {
                key: 'pattern',
                value: function () {
                  return this._format[0];
                },
              },
              {
                key: 'format',
                value: function () {
                  return this._format[1];
                },
              },
              {
                key: 'leadingDigitsPatterns',
                value: function () {
                  return this._format[2] || [];
                },
              },
              {
                key: 'nationalPrefixFormattingRule',
                value: function () {
                  return this._format[3] || this.metadata.nationalPrefixFormattingRule();
                },
              },
              {
                key: 'nationalPrefixIsOptionalWhenFormatting',
                value: function () {
                  return (
                    !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormatting()
                  );
                },
              },
              {
                key: 'nationalPrefixIsMandatoryWhenFormatting',
                value: function () {
                  return (
                    this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormatting()
                  );
                },
              },
              {
                key: 'usesNationalPrefix',
                value: function () {
                  return (
                    this.nationalPrefixFormattingRule() &&
                    '$1' !== this.nationalPrefixFormattingRule() &&
                    /\d/.test(this.nationalPrefixFormattingRule().replace('$1', ''))
                  );
                },
              },
              {
                key: 'internationalFormat',
                value: function () {
                  return this._format[5] || this.format();
                },
              },
            ]),
            t
          );
        })(),
        c = (function () {
          function t(d, e) {
            u(this, t), (this.type = d), (this.metadata = e);
          }
          return (
            o(t, [
              {
                key: 'pattern',
                value: function () {
                  return this.metadata.v1 ? this.type : this.type[0];
                },
              },
              {
                key: 'possibleLengths',
                value: function () {
                  if (!this.metadata.v1) return this.type[1] || this.metadata.possibleLengths();
                },
              },
            ]),
            t
          );
        })();
      function h(t, d) {
        switch (d) {
          case 'FIXED_LINE':
            return t[0];
          case 'MOBILE':
            return t[1];
          case 'TOLL_FREE':
            return t[2];
          case 'PREMIUM_RATE':
            return t[3];
          case 'PERSONAL_NUMBER':
            return t[4];
          case 'VOICEMAIL':
            return t[5];
          case 'UAN':
            return t[6];
          case 'PAGER':
            return t[7];
          case 'VOIP':
            return t[8];
          case 'SHARED_COST':
            return t[9];
        }
      }
      function y(t) {
        if (!t)
          throw new Error(
            '[libphonenumber-js] `metadata` argument not passed. Check your arguments.',
          );
        if (
          !p(t) ||
          !p(t.countries) ||
          (!p(t.country_calling_codes) && !p(t.country_phone_code_to_countries))
        )
          throw new Error(
            "[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` and `.country_calling_codes` child object properties. Got " +
              (p(t)
                ? 'an object of shape: { ' + Object.keys(t).join(', ') + ' }'
                : 'a ' + m(t) + ': ' + t) +
              '.',
          );
      }
      var p = function (t) {
          return 'object' === (void 0 === t ? 'undefined' : i(t));
        },
        m = function (t) {
          return void 0 === t ? 'undefined' : i(t);
        };
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 });
      var r =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                'function' == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            };
      (d.default = function (t, d, e, r) {
        var u = (function (t, d, e, r) {
            var n = void 0,
              $ = void 0,
              i = void 0;
            if ('string' != typeof t)
              throw new TypeError('A phone number for parsing must be a string.');
            n = t;
            'object' !== (void 0 === d ? 'undefined' : y(d))
              ? r
                ? (($ = h({ defaultCountry: d }, e)), (i = r))
                : (($ = { defaultCountry: d }), (i = e))
              : e
              ? (($ = d), (i = e))
              : (i = d);
            $ = $ ? h({}, A, $) : A;
            return { text: n, options: $, metadata: new a.default(i) };
          })(t, d, e, r),
          c = u.text,
          m = u.options,
          _ = u.metadata;
        if (m.defaultCountry && !_.hasCountry(m.defaultCountry)) {
          if (m.v2) throw new Error('INVALID_COUNTRY');
          throw new Error('Unknown country: ' + m.defaultCountry);
        }
        var b = (function (t, d) {
            if (t && 0 === t.indexOf('tel:')) return (0, l.parseRFC3966)(t);
            var e = I(t, d);
            if (!e || !P(e)) return {};
            var r = (function (t) {
              var d = t.search(v);
              if (d < 0) return {};
              var e = t.slice(0, d);
              if (!P(e)) return {};
              var r = t.match(v),
                n = 1;
              for (; n < r.length; ) {
                if (null != r[n] && r[n].length > 0) return { number: e, ext: r[n] };
                n++;
              }
            })(e);
            if (r.ext) return r;
            return { number: e };
          })(c, m.v2),
          g = b.number,
          C = b.ext;
        if (!g) {
          if (m.v2) throw new Error('NOT_A_NUMBER');
          return {};
        }
        var N = (function (t, d, e) {
            var r = (0, n.extractCountryCallingCode)(t, d, e.metadata),
              a = r.countryCallingCode,
              u = r.number;
            if (!u) return { countryCallingCode: a };
            var s = void 0;
            if (a) e.chooseCountryByCountryCallingCode(a);
            else {
              if (!d) return {};
              e.country(d), (s = d), (a = (0, i.default)(d, e.metadata));
            }
            var l = (function (t, d) {
                var e = (0, $.default)(t),
                  r = void 0,
                  a = S(e, d),
                  i = a.number,
                  u = a.carrierCode;
                if (d.possibleLengths())
                  switch ((0, o.check_number_length_for_type)(i, void 0, d)) {
                    case 'TOO_SHORT':
                    case 'INVALID_LENGTH':
                      break;
                    default:
                      (e = i), (r = u);
                  }
                else
                  ((0, n.matches_entirely)(e, d.nationalNumberPattern()) &&
                    !(0, n.matches_entirely)(i, d.nationalNumberPattern())) ||
                    ((e = i), (r = u));
                return { national_number: e, carrier_code: r };
              })(u, e),
              f = l.national_number,
              c = l.carrier_code,
              h = E(a, f, e);
            h && ((s = h), e.country(s));
            return { country: s, countryCallingCode: a, national_number: f, carrierCode: c };
          })(g, m.defaultCountry, _),
          x = N.country,
          O = N.national_number,
          T = N.countryCallingCode,
          R = N.carrierCode;
        if (!_.selectedCountry()) {
          if (m.v2) throw new Error('INVALID_COUNTRY');
          return {};
        }
        if (O.length < p) {
          if (m.v2) throw new Error('TOO_SHORT');
          return {};
        }
        if (O.length > n.MAX_LENGTH_FOR_NSN) {
          if (m.v2) throw new Error('TOO_LONG');
          return {};
        }
        if (m.v2) {
          var M = new f.default(T, O, _.metadata);
          return x && (M.country = x), R && (M.carrierCode = R), C && (M.ext = C), M;
        }
        var L = !(!x || !(0, n.matches_entirely)(O, _.nationalNumberPattern()));
        if (!m.extended)
          return L
            ? (function (t, d, e) {
                var r = { country: t, phone: d };
                e && (r.ext = e);
                return r;
              })(x, O, C)
            : {};
        return {
          country: x,
          countryCallingCode: T,
          carrierCode: R,
          valid: L,
          possible:
            !!L ||
            (!0 === m.extended &&
              _.possibleLengths() &&
              (0, s.is_possible_number)(O, void 0 !== T, _)),
          phone: O,
          ext: C,
        };
      }),
        (d.is_viable_phone_number = P),
        (d.extract_formatted_phone_number = I),
        (d.strip_national_prefix_and_carrier_code = S),
        (d.find_country_code = E);
      var n = e(0),
        $ = c(e(8)),
        a = c(e(1)),
        i = c(e(18)),
        o = e(3),
        u = c(o),
        s = e(12),
        l = e(11),
        f = c(e(5));
      function c(t) {
        return t && t.__esModule ? t : { default: t };
      }
      var h =
          Object.assign ||
          function (t) {
            for (var d = 1; d < arguments.length; d++) {
              var e = arguments[d];
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }
            return t;
          },
        y =
          'function' == typeof Symbol && 'symbol' === r(Symbol.iterator)
            ? function (t) {
                return void 0 === t ? 'undefined' : r(t);
              }
            : function (t) {
                return t &&
                  'function' == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? 'symbol'
                  : void 0 === t
                  ? 'undefined'
                  : r(t);
              },
        p = 2,
        m = 250,
        _ = (0, n.create_extension_pattern)('parsing'),
        v = new RegExp('(?:' + _ + ')$', 'i'),
        b = '[' + n.VALID_DIGITS + ']{' + p + '}',
        g =
          '[' +
          n.PLUS_CHARS +
          ']{0,1}(?:[' +
          n.VALID_PUNCTUATION +
          ']*[' +
          n.VALID_DIGITS +
          ']){3,}[' +
          n.VALID_PUNCTUATION +
          n.VALID_DIGITS +
          ']*',
        C = new RegExp('^' + b + '$|^' + g + '(?:' + _ + ')?$', 'i'),
        N = new RegExp('[' + n.PLUS_CHARS + n.VALID_DIGITS + ']'),
        x = new RegExp('[^' + n.VALID_DIGITS + ']+$'),
        A = { country: {} };
      function P(t) {
        return t.length >= p && C.test(t);
      }
      function I(t, d) {
        if (t)
          if (t.length > m) {
            if (d) throw new Error('TOO_LONG');
          } else {
            var e = t.search(N);
            if (!(e < 0)) return t.slice(e).replace(x, '');
          }
      }
      function S(t, d) {
        if (!t || !d.nationalPrefixForParsing()) return { number: t };
        var e = new RegExp('^(?:' + d.nationalPrefixForParsing() + ')'),
          r = e.exec(t);
        if (!r) return { number: t };
        var n = void 0,
          $ = r.length - 1;
        n =
          d.nationalPrefixTransformRule() && r[$]
            ? t.replace(e, d.nationalPrefixTransformRule())
            : t.slice(r[0].length);
        var a = void 0;
        return $ > 0 && (a = r[1]), { number: n, carrierCode: a };
      }
      function E(t, d, e) {
        var r = e.countryCallingCodes()[t];
        return 1 === r.length
          ? r[0]
          : (function (t, d, e) {
              e = new a.default(e);
              for (var r = t, n = Array.isArray(r), $ = 0, r = n ? r : r[Symbol.iterator](); ; ) {
                var i;
                if (n) {
                  if ($ >= r.length) break;
                  i = r[$++];
                } else {
                  if (($ = r.next()).done) break;
                  i = $.value;
                }
                var o = i;
                if ((e.country(o), e.leadingDigits())) {
                  if (d && 0 === d.search(e.leadingDigits())) return o;
                } else if ((0, u.default)({ phone: d, country: o }, e.metadata)) return o;
              }
            })(r, d, e.metadata);
      }
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 });
      var r =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                'function' == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            };
      (d.default = function (t, d, e, r) {
        var n = f(t, d, e, r),
          $ = n.input,
          i = n.options,
          o = n.metadata;
        if (!$.country) return;
        if (!o.hasCountry($.country)) throw new Error('Unknown country: ' + $.country);
        var u = i.v2 ? $.nationalNumber : $.phone;
        if ((o.country($.country), !(0, a.matches_entirely)(u, o.nationalNumberPattern()))) return;
        if (l(u, 'FIXED_LINE', o))
          return o.type('MOBILE') && '' === o.type('MOBILE').pattern()
            ? 'FIXED_LINE_OR_MOBILE'
            : o.type('MOBILE')
            ? l(u, 'MOBILE', o)
              ? 'FIXED_LINE_OR_MOBILE'
              : 'FIXED_LINE'
            : 'FIXED_LINE_OR_MOBILE';
        for (var c = s, h = Array.isArray(c), y = 0, c = h ? c : c[Symbol.iterator](); ; ) {
          var p;
          if (h) {
            if (y >= c.length) break;
            p = c[y++];
          } else {
            if ((y = c.next()).done) break;
            p = y.value;
          }
          var m = p;
          if (l(u, m, o)) return m;
        }
      }),
        (d.is_of_type = l),
        (d.sort_out_arguments = f),
        (d.check_number_length_for_type = function t(d, e, r) {
          var n = r.type(e);
          var $ = (n && n.possibleLengths()) || r.possibleLengths();
          if ('FIXED_LINE_OR_MOBILE' === e) {
            if (!r.type('FIXED_LINE')) return t(d, 'MOBILE', r);
            var a = r.type('MOBILE');
            a && ($ = h($, a.possibleLengths()));
          } else if (e && !n) return 'INVALID_LENGTH';
          var i = d.length;
          var o = $[0];
          if (o === i) return 'IS_POSSIBLE';
          if (o > i) return 'TOO_SHORT';
          if ($[$.length - 1] < i) return 'TOO_LONG';
          return $.indexOf(i, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
        }),
        (d.merge_arrays = h);
      var n = e(2),
        $ = o(n),
        a = e(0),
        i = o(e(1));
      function o(t) {
        return t && t.__esModule ? t : { default: t };
      }
      var u =
          'function' == typeof Symbol && 'symbol' === r(Symbol.iterator)
            ? function (t) {
                return void 0 === t ? 'undefined' : r(t);
              }
            : function (t) {
                return t &&
                  'function' == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? 'symbol'
                  : void 0 === t
                  ? 'undefined'
                  : r(t);
              },
        s = [
          'MOBILE',
          'PREMIUM_RATE',
          'TOLL_FREE',
          'SHARED_COST',
          'VOIP',
          'PERSONAL_NUMBER',
          'PAGER',
          'UAN',
          'VOICEMAIL',
        ];
      function l(t, d, e) {
        return (
          !(!(d = e.type(d)) || !d.pattern()) &&
          !(d.possibleLengths() && d.possibleLengths().indexOf(t.length) < 0) &&
          (0, a.matches_entirely)(t, d.pattern())
        );
      }
      function f(t, d, e, r) {
        var a = void 0,
          o = {},
          s = void 0;
        if ('string' == typeof t)
          'object' !== (void 0 === d ? 'undefined' : u(d))
            ? (r ? ((o = e), (s = r)) : (s = e),
              (a = (0, n.is_viable_phone_number)(t) ? (0, $.default)(t, d, s) : {}))
            : (e ? ((o = d), (s = e)) : (s = d),
              (a = (0, n.is_viable_phone_number)(t) ? (0, $.default)(t, s) : {}));
        else {
          if (!c(t))
            throw new TypeError(
              'A phone number must either be a string or an object of shape { phone, [country] }.',
            );
          (a = t), e ? ((o = d), (s = e)) : (s = d);
        }
        return { input: a, options: o, metadata: new i.default(s) };
      }
      var c = function (t) {
        return 'object' === (void 0 === t ? 'undefined' : u(t));
      };
      function h(t, d) {
        var e = t.slice(),
          r = d,
          n = Array.isArray(r),
          $ = 0;
        for (r = n ? r : r[Symbol.iterator](); ; ) {
          var a;
          if (n) {
            if ($ >= r.length) break;
            a = r[$++];
          } else {
            if (($ = r.next()).done) break;
            a = $.value;
          }
          var i = a;
          t.indexOf(i) < 0 && e.push(i);
        }
        return e.sort(function (t, d) {
          return t - d;
        });
      }
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.default = function (t, d, e, r) {
          var i = (0, n.sort_out_arguments)(t, d, e, r),
            o = i.input,
            u = i.options,
            s = i.metadata;
          if (!o.country) return !1;
          if (!s.hasCountry(o.country)) throw new Error('Unknown country: ' + o.country);
          if ((s.country(o.country), s.hasTypes()))
            return void 0 !== (0, $.default)(o, u, s.metadata);
          var l = u.v2 ? o.nationalNumber : o.phone;
          return (0, a.matches_entirely)(l, s.nationalNumberPattern());
        });
      var r,
        n = e(3),
        $ = (r = n) && r.__esModule ? r : { default: r },
        a = e(0);
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 });
      var r = o(e(1)),
        n = o(e(12)),
        $ = o(e(4)),
        a = o(e(3)),
        i = o(e(7));
      function o(t) {
        return t && t.__esModule ? t : { default: t };
      }
      var u =
          Object.assign ||
          function (t) {
            for (var d = 1; d < arguments.length; d++) {
              var e = arguments[d];
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }
            return t;
          },
        s = (function () {
          function t(t, d) {
            for (var e = 0; e < d.length; e++) {
              var r = d[e];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                'value' in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (d, e, r) {
            return e && t(d.prototype, e), r && t(d, r), d;
          };
        })();
      var l = (function () {
        function t(d, e, n) {
          if (
            ((function (t, d) {
              if (!(t instanceof d)) throw new TypeError('Cannot call a class as a function');
            })(this, t),
            !d)
          )
            throw new TypeError('`countryCallingCode` not passed');
          if (!e) throw new TypeError('`nationalNumber` not passed');
          if (f(d)) {
            this.country = d;
            var $ = new r.default(n);
            $.country(d), (d = $.countryCallingCode());
          }
          (this.countryCallingCode = d),
            (this.nationalNumber = e),
            (this.number = '+' + this.countryCallingCode + this.nationalNumber),
            (this.metadata = n);
        }
        return (
          s(t, [
            {
              key: 'isPossible',
              value: function () {
                return (0, n.default)(this, { v2: !0 }, this.metadata);
              },
            },
            {
              key: 'isValid',
              value: function () {
                return (0, $.default)(this, { v2: !0 }, this.metadata);
              },
            },
            {
              key: 'getType',
              value: function () {
                return (0, a.default)(this, { v2: !0 }, this.metadata);
              },
            },
            {
              key: 'format',
              value: function (t, d) {
                return (0, i.default)(
                  this,
                  t,
                  d ? u({}, d, { v2: !0 }) : { v2: !0 },
                  this.metadata,
                );
              },
            },
            {
              key: 'formatNational',
              value: function (t) {
                return this.format('NATIONAL', t);
              },
            },
            {
              key: 'formatInternational',
              value: function (t) {
                return this.format('INTERNATIONAL', t);
              },
            },
            {
              key: 'getURI',
              value: function (t) {
                return this.format('RFC3966', t);
              },
            },
          ]),
          t
        );
      })();
      d.default = l;
      var f = function (t) {
        return /^[A-Z]{2}$/.test(t);
      };
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.limit = function (t, d) {
          if (t < 0 || d <= 0 || d < t) throw new TypeError();
          return '{' + t + ',' + d + '}';
        }),
        (d.trimAfterFirstMatch = function (t, d) {
          var e = d.search(t);
          if (e >= 0) return d.slice(0, e);
          return d;
        }),
        (d.startsWith = function (t, d) {
          return 0 === t.indexOf(d);
        }),
        (d.endsWith = function (t, d) {
          return t.indexOf(d, t.length - d.length) === t.length - d.length;
        });
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }), (d.FIRST_GROUP_PATTERN = void 0);
      var r =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                'function' == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            };
      (d.default = function (t, d, e, r, n) {
        var u = (function (t, d, e, r, n) {
            var a = void 0,
              o = void 0,
              u = void 0,
              s = void 0;
            if ('string' == typeof t)
              if ('string' == typeof e)
                (o = e),
                  n ? ((u = r), (s = n)) : (s = r),
                  (a = (0, $.default)(t, { defaultCountry: d, extended: !0 }, s));
              else {
                if ('string' != typeof d)
                  throw new Error('`format` argument not passed to `formatNumber(number, format)`');
                (o = d),
                  r ? ((u = e), (s = r)) : (s = e),
                  (a = (0, $.default)(t, { extended: !0 }, s));
              }
            else {
              if (!_(t))
                throw new TypeError(
                  'A phone number must either be a string or an object of shape { phone, [country] }.',
                );
              (a = t), (o = d), r ? ((u = e), (s = r)) : (s = e);
            }
            'International' === o ? (o = 'INTERNATIONAL') : 'National' === o && (o = 'NATIONAL');
            switch (o) {
              case 'E.164':
              case 'INTERNATIONAL':
              case 'NATIONAL':
              case 'RFC3966':
              case 'IDD':
                break;
              default:
                throw new Error('Unknown format type argument passed to "format()": "' + o + '"');
            }
            u = u ? l({}, f, u) : f;
            return { input: a, format_type: o, options: u, metadata: new i.default(s) };
          })(t, d, e, r, n),
          s = u.input,
          c = u.format_type,
          h = u.options,
          p = u.metadata;
        if (s.country) {
          if (!p.hasCountry(s.country)) throw new Error('Unknown country: ' + s.country);
          p.country(s.country);
        } else {
          if (!s.countryCallingCode) return s.phone || '';
          p.chooseCountryByCountryCallingCode(s.countryCallingCode);
        }
        var m = p.countryCallingCode(),
          g = h.v2 ? s.nationalNumber : s.phone,
          C = void 0;
        switch (c) {
          case 'INTERNATIONAL':
            return g
              ? ((C = y(g, 'INTERNATIONAL', p)),
                v((C = '+' + m + ' ' + C), s.ext, p, h.formatExtension))
              : '+' + m;
          case 'E.164':
            return '+' + m + g;
          case 'RFC3966':
            return (0, o.formatRFC3966)({ number: '+' + m + g, ext: s.ext });
          case 'IDD':
            if (!h.fromCountry) return;
            var N = (0, a.getIDDPrefix)(h.fromCountry, p.metadata);
            if (!N) return;
            if (h.humanReadable) {
              var x = m && b(g, p.countryCallingCode(), h.fromCountry, p);
              return v(
                (C = x || N + ' ' + m + ' ' + y(g, 'INTERNATIONAL', p)),
                s.ext,
                p,
                h.formatExtension,
              );
            }
            return '' + N + m + g;
          case 'NATIONAL':
            return g ? v((C = y(g, 'NATIONAL', p)), s.ext, p, h.formatExtension) : '';
        }
      }),
        (d.format_national_number_using_format = h),
        (d.choose_format_for_number = p),
        (d.changeInternationalFormatStyle = m),
        (d.formatIDDSameCountryCallingCodeNumber = b);
      var n = e(0),
        $ = u(e(2)),
        a = e(19),
        i = u(e(1)),
        o = e(11);
      function u(t) {
        return t && t.__esModule ? t : { default: t };
      }
      var s =
          'function' == typeof Symbol && 'symbol' === r(Symbol.iterator)
            ? function (t) {
                return void 0 === t ? 'undefined' : r(t);
              }
            : function (t) {
                return t &&
                  'function' == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? 'symbol'
                  : void 0 === t
                  ? 'undefined'
                  : r(t);
              },
        l =
          Object.assign ||
          function (t) {
            for (var d = 1; d < arguments.length; d++) {
              var e = arguments[d];
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }
            return t;
          },
        f = {
          formatExtension: function (t, d, e) {
            return '' + t + e.ext() + d;
          },
        };
      var c = (d.FIRST_GROUP_PATTERN = /(\$\d)/);
      function h(t, d, e, r, n) {
        var $ = t.replace(
          new RegExp(d.pattern()),
          e
            ? d.internationalFormat()
            : !d.nationalPrefixFormattingRule() ||
              (d.nationalPrefixIsOptionalWhenFormatting() && !r)
            ? d.format()
            : d.format().replace(c, d.nationalPrefixFormattingRule()),
        );
        return e ? m($) : $;
      }
      function y(t, d, e) {
        var r = p(e.formats(), t);
        return r ? h(t, r, 'INTERNATIONAL' === d, !0) : t;
      }
      function p(t, d) {
        var e = t,
          r = Array.isArray(e),
          $ = 0;
        for (e = r ? e : e[Symbol.iterator](); ; ) {
          var a;
          if (r) {
            if ($ >= e.length) break;
            a = e[$++];
          } else {
            if (($ = e.next()).done) break;
            a = $.value;
          }
          var i = a;
          if (i.leadingDigitsPatterns().length > 0) {
            var o = i.leadingDigitsPatterns()[i.leadingDigitsPatterns().length - 1];
            if (0 !== d.search(o)) continue;
          }
          if ((0, n.matches_entirely)(d, i.pattern())) return i;
        }
      }
      function m(t) {
        return t.replace(new RegExp('[' + n.VALID_PUNCTUATION + ']+', 'g'), ' ').trim();
      }
      var _ = function (t) {
        return 'object' === (void 0 === t ? 'undefined' : s(t));
      };
      function v(t, d, e, r) {
        return d ? r(t, d, e) : t;
      }
      function b(t, d, e, r) {
        var n = new i.default(r.metadata);
        if ((n.country(e), d === n.countryCallingCode()))
          return '1' === d ? d + ' ' + y(t, 'NATIONAL', r) : y(t, 'NATIONAL', r);
      }
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.default = function (t) {
          for (
            var d = '',
              e = t.split(''),
              r = Array.isArray(e),
              $ = 0,
              e = r ? e : e[Symbol.iterator]();
            ;

          ) {
            var a;
            if (r) {
              if ($ >= e.length) break;
              a = e[$++];
            } else {
              if (($ = e.next()).done) break;
              a = $.value;
            }
            var i = a;
            d += n(i, d) || '';
          }
          return d;
        }),
        (d.parsePhoneNumberCharacter = n);
      var r = e(0);
      function n(t, d) {
        if ('+' === t) {
          if (d) return;
          return '+';
        }
        return (0, r.parseDigit)(t);
      }
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 });
      var r = c(e(5)),
        n = e(0),
        $ = e(6),
        a = e(14),
        i = c(e(22)),
        o = c(e(17)),
        u = c(e(16)),
        s = e(15),
        l = c(s),
        f = (c(e(7)), c(e(2)));
      c(e(4));
      function c(t) {
        return t && t.__esModule ? t : { default: t };
      }
      var h =
          Object.assign ||
          function (t) {
            for (var d = 1; d < arguments.length; d++) {
              var e = arguments[d];
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }
            return t;
          },
        y = (function () {
          function t(t, d) {
            for (var e = 0; e < d.length; e++) {
              var r = d[e];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                'value' in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (d, e, r) {
            return e && t(d.prototype, e), r && t(d, r), d;
          };
        })();
      var p = [
          '\\/+(.*)/',
          '(\\([^(]*)',
          '(?:' + a.pZ + '-|-' + a.pZ + ')' + a.pZ + '*(.+)',
          '[‒-―－]' + a.pZ + '*(.+)',
          '\\.+' + a.pZ + '*([^.]+)',
          a.pZ + '+(' + a.PZ + '+)',
        ],
        m = (0, $.limit)(0, 2),
        _ = (0, $.limit)(0, 4),
        v = n.MAX_LENGTH_FOR_NSN + n.MAX_LENGTH_COUNTRY_CODE,
        b = (0, $.limit)(0, v),
        g = '[' + n.VALID_PUNCTUATION + ']' + _,
        C = a.pNd + (0, $.limit)(1, v),
        N =
          '(?:' +
          s.LEAD_CLASS +
          g +
          ')' +
          m +
          C +
          '(?:' +
          g +
          C +
          ')' +
          b +
          '(?:' +
          (0, n.create_extension_pattern)('matching') +
          ')?',
        x = new RegExp('[^' + a._pN + a._pL + '#]+$'),
        A = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1,
        P = (function () {
          function t() {
            var d = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '',
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = arguments[2];
            if (
              ((function (t, d) {
                if (!(t instanceof d)) throw new TypeError('Cannot call a class as a function');
              })(this, t),
              (this.state = 'NOT_READY'),
              (this.searchIndex = 0),
              !(e = h({}, e, {
                leniency: e.leniency || e.extended ? 'POSSIBLE' : 'VALID',
                maxTries: e.maxTries || A,
              })).leniency)
            )
              throw new TypeError('`Leniency` not supplied');
            if (e.maxTries < 0) throw new TypeError('`maxTries` not supplied');
            if (
              ((this.text = d),
              (this.options = e),
              (this.metadata = r),
              (this.leniency = i.default[e.leniency]),
              !this.leniency)
            )
              throw new TypeError('Unknown leniency: ' + e.leniency + '.');
            (this.maxTries = e.maxTries), (this.PATTERN = new RegExp(N, 'ig'));
          }
          return (
            y(t, [
              {
                key: 'find',
                value: function () {
                  for (
                    var t = void 0;
                    this.maxTries > 0 && null !== (t = this.PATTERN.exec(this.text));

                  ) {
                    var d = t[0],
                      e = t.index;
                    if (((d = (0, o.default)(d)), (0, u.default)(d, e, this.text))) {
                      var n =
                        this.parseAndVerify(d, e, this.text) ||
                        this.extractInnerMatch(d, e, this.text);
                      if (n) {
                        if (this.options.v2) {
                          var $ = new r.default(n.country, n.phone, this.metadata.metadata);
                          return (
                            n.ext && ($.ext = n.ext),
                            { startsAt: n.startsAt, endsAt: n.endsAt, number: $ }
                          );
                        }
                        return n;
                      }
                    }
                    this.maxTries--;
                  }
                },
              },
              {
                key: 'extractInnerMatch',
                value: function (t, d, e) {
                  var r = p,
                    n = Array.isArray(r),
                    a = 0;
                  for (r = n ? r : r[Symbol.iterator](); ; ) {
                    var i;
                    if (n) {
                      if (a >= r.length) break;
                      i = r[a++];
                    } else {
                      if ((a = r.next()).done) break;
                      i = a.value;
                    }
                    for (
                      var o = !0, u = void 0, s = new RegExp(i, 'g');
                      null !== (u = s.exec(t)) && this.maxTries > 0;

                    ) {
                      if (o) {
                        var l = (0, $.trimAfterFirstMatch)(x, t.slice(0, u.index)),
                          f = this.parseAndVerify(l, d, e);
                        if (f) return f;
                        this.maxTries--, (o = !1);
                      }
                      var c = (0, $.trimAfterFirstMatch)(x, u[1]),
                        h = this.parseAndVerify(c, d + u.index, e);
                      if (h) return h;
                      this.maxTries--;
                    }
                  }
                },
              },
              {
                key: 'parseAndVerify',
                value: function (t, d, e) {
                  if ((0, l.default)(t, d, e, this.options.leniency)) {
                    var r = (0, f.default)(
                      t,
                      { extended: !0, defaultCountry: this.options.defaultCountry },
                      this.metadata.metadata,
                    );
                    if (r.possible && this.leniency(r, t, this.metadata.metadata)) {
                      var n = {
                        startsAt: d,
                        endsAt: d + t.length,
                        country: r.country,
                        phone: r.phone,
                      };
                      return r.ext && (n.ext = r.ext), n;
                    }
                  }
                },
              },
              {
                key: 'hasNext',
                value: function () {
                  return (
                    'NOT_READY' === this.state &&
                      ((this.lastMatch = this.find()),
                      this.lastMatch ? (this.state = 'READY') : (this.state = 'DONE')),
                    'READY' === this.state
                  );
                },
              },
              {
                key: 'next',
                value: function () {
                  if (!this.hasNext()) throw new Error('No next element');
                  var t = this.lastMatch;
                  return (this.lastMatch = null), (this.state = 'NOT_READY'), t;
                },
              },
            ]),
            t
          );
        })();
      d.default = P;
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }), (d.PhoneNumberSearch = void 0);
      var r =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                'function' == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            };
      (d.default = function (t, d, e, r) {
        var n = v(t, d, e, r),
          $ = n.text,
          a = n.options,
          i = n.metadata,
          o = new _($, a, i.metadata),
          u = [];
        for (; o.hasNext(); ) u.push(o.next());
        return u;
      }),
        (d.searchPhoneNumbers = function (t, d, e, r) {
          var n = v(t, d, e, r),
            $ = n.text,
            a = n.options,
            i = n.metadata,
            o = new _($, a, i.metadata);
          return (function (t, d, e) {
            d in t
              ? Object.defineProperty(t, d, {
                  value: e,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (t[d] = e);
            return t;
          })({}, Symbol.iterator, function () {
            return {
              next: function () {
                return o.hasNext() ? { done: !1, value: o.next() } : { done: !0 };
              },
            };
          });
        }),
        (d.sort_out_arguments = v);
      var n = s(e(2)),
        $ = s(e(1)),
        a = e(0),
        i = s(e(17)),
        o = s(e(16)),
        u = s(e(15));
      function s(t) {
        return t && t.__esModule ? t : { default: t };
      }
      var l =
          Object.assign ||
          function (t) {
            for (var d = 1; d < arguments.length; d++) {
              var e = arguments[d];
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }
            return t;
          },
        f =
          'function' == typeof Symbol && 'symbol' === r(Symbol.iterator)
            ? function (t) {
                return void 0 === t ? 'undefined' : r(t);
              }
            : function (t) {
                return t &&
                  'function' == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? 'symbol'
                  : void 0 === t
                  ? 'undefined'
                  : r(t);
              },
        c = (function () {
          function t(t, d) {
            for (var e = 0; e < d.length; e++) {
              var r = d[e];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                'value' in r && (r.writable = !0),
                Object.defineProperty(t, r.key, r);
            }
          }
          return function (d, e, r) {
            return e && t(d.prototype, e), r && t(d, r), d;
          };
        })();
      var h =
          '[' +
          a.PLUS_CHARS +
          ']{0,1}(?:[' +
          a.VALID_PUNCTUATION +
          ']*[' +
          a.VALID_DIGITS +
          ']){3,}[' +
          a.VALID_PUNCTUATION +
          a.VALID_DIGITS +
          ']*',
        y = (0, a.create_extension_pattern)('parsing'),
        p = new RegExp('^[' + a.WHITESPACE + ']+'),
        m = new RegExp('[' + a.VALID_PUNCTUATION + ']+$');
      var _ = (d.PhoneNumberSearch = (function () {
        function t(d) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = arguments[2];
          !(function (t, d) {
            if (!(t instanceof d)) throw new TypeError('Cannot call a class as a function');
          })(this, t),
            (this.state = 'NOT_READY'),
            (this.text = d),
            (this.options = e),
            (this.metadata = r),
            (this.regexp = new RegExp(h + '(?:' + y + ')?', 'ig'));
        }
        return (
          c(t, [
            {
              key: 'find',
              value: function () {
                var t = this.regexp.exec(this.text);
                if (t) {
                  var d = t[0],
                    e = t.index;
                  (d = d.replace(p, '')),
                    (e += t[0].length - d.length),
                    (d = d.replace(m, '')),
                    (d = (0, i.default)(d));
                  var r = this.parseCandidate(d, e);
                  return r || this.find();
                }
              },
            },
            {
              key: 'parseCandidate',
              value: function (t, d) {
                if (
                  (0, o.default)(t, d, this.text) &&
                  (0, u.default)(t, d, this.text, this.options.extended ? 'POSSIBLE' : 'VALID')
                ) {
                  var e = (0, n.default)(t, this.options, this.metadata);
                  if (e.phone) return (e.startsAt = d), (e.endsAt = d + t.length), e;
                }
              },
            },
            {
              key: 'hasNext',
              value: function () {
                return (
                  'NOT_READY' === this.state &&
                    ((this.last_match = this.find()),
                    this.last_match ? (this.state = 'READY') : (this.state = 'DONE')),
                  'READY' === this.state
                );
              },
            },
            {
              key: 'next',
              value: function () {
                if (!this.hasNext()) throw new Error('No next element');
                var t = this.last_match;
                return (this.last_match = null), (this.state = 'NOT_READY'), t;
              },
            },
          ]),
          t
        );
      })());
      function v(t, d, e, r) {
        var n = void 0,
          a = void 0,
          i = void 0;
        if ('string' != typeof t) throw new TypeError('A text for parsing must be a string.');
        return (
          (n = t),
          'object' !== (void 0 === d ? 'undefined' : f(d))
            ? r
              ? ((a = l({ defaultCountry: d }, e)), (i = r))
              : ((a = { defaultCountry: d }), (i = e))
            : e
            ? ((a = d), (i = e))
            : (i = d),
          a || (a = {}),
          { text: n, options: a, metadata: new $.default(i) }
        );
      }
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.parseRFC3966 = function (t) {
          for (
            var d = void 0,
              e = void 0,
              $ = (t = t.replace(/^tel:/, 'tel=')).split(';'),
              a = Array.isArray($),
              i = 0,
              $ = a ? $ : $[Symbol.iterator]();
            ;

          ) {
            var o;
            if (a) {
              if (i >= $.length) break;
              o = $[i++];
            } else {
              if ((i = $.next()).done) break;
              o = i.value;
            }
            var u = o,
              s = u.split('='),
              l = n(s, 2),
              f = l[0],
              c = l[1];
            switch (f) {
              case 'tel':
                d = c;
                break;
              case 'ext':
                e = c;
                break;
              case 'phone-context':
                '+' === c[0] && (d = c + d);
            }
          }
          if (!(0, r.is_viable_phone_number)(d)) return {};
          var h = { number: d };
          e && (h.ext = e);
          return h;
        }),
        (d.formatRFC3966 = function (t) {
          var d = t.number,
            e = t.ext;
          if (!d) return '';
          if ('+' !== d[0])
            throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
          return 'tel:' + d + (e ? ';ext=' + e : '');
        });
      var r = e(2),
        n = (function () {
          return function (t, d) {
            if (Array.isArray(t)) return t;
            if (Symbol.iterator in Object(t))
              return (function (t, d) {
                var e = [],
                  r = !0,
                  n = !1,
                  $ = void 0;
                try {
                  for (
                    var a, i = t[Symbol.iterator]();
                    !(r = (a = i.next()).done) && (e.push(a.value), !d || e.length !== d);
                    r = !0
                  );
                } catch (t) {
                  (n = !0), ($ = t);
                } finally {
                  try {
                    !r && i.return && i.return();
                  } finally {
                    if (n) throw $;
                  }
                }
                return e;
              })(t, d);
            throw new TypeError('Invalid attempt to destructure non-iterable instance');
          };
        })();
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.default = function (t, d, e, $) {
          var a = (0, r.sort_out_arguments)(t, d, e, $),
            i = a.input,
            o = a.options,
            u = a.metadata;
          if (o.v2) {
            if (!i.countryCallingCode) throw new Error('Invalid phone number object passed');
            u.chooseCountryByCountryCallingCode(i.countryCallingCode);
          } else {
            if (!i.phone) return !1;
            if (i.country) {
              if (!u.hasCountry(i.country)) throw new Error('Unknown country: ' + i.country);
              u.country(i.country);
            } else {
              if (!i.countryCallingCode) throw new Error('Invalid phone number object passed');
              u.chooseCountryByCountryCallingCode(i.countryCallingCode);
            }
          }
          if (!u.possibleLengths()) throw new Error('Metadata too old');
          return n(i.phone || i.nationalNumber, void 0, u);
        }),
        (d.is_possible_number = n);
      var r = e(3);
      function n(t, d, e) {
        switch ((0, r.check_number_length_for_type)(t, void 0, e)) {
          case 'IS_POSSIBLE':
            return !0;
          default:
            return !1;
        }
      }
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.DIGIT_PLACEHOLDER = void 0),
        (d.strip_dangling_braces = v),
        (d.cut_stripping_dangling_braces = b),
        (d.close_dangling_braces = function (t, d) {
          var e = t.slice(0, d),
            r = g('(', e),
            n = g(')', e),
            $ = r - n;
          for (; $ > 0 && d < t.length; ) ')' === t[d] && $--, d++;
          return t.slice(0, d);
        }),
        (d.count_occurences = g),
        (d.repeat = C);
      var r = s(e(1)),
        n = s(e(5)),
        $ = e(0),
        a = e(2),
        i = e(7),
        o = e(3),
        u = s(e(8));
      function s(t) {
        return t && t.__esModule ? t : { default: t };
      }
      var l = (function () {
        function t(t, d) {
          for (var e = 0; e < d.length; e++) {
            var r = d[e];
            (r.enumerable = r.enumerable || !1),
              (r.configurable = !0),
              'value' in r && (r.writable = !0),
              Object.defineProperty(t, r.key, r);
          }
        }
        return function (d, e, r) {
          return e && t(d.prototype, e), r && t(d, r), d;
        };
      })();
      var f = C('9', 15),
        c = (d.DIGIT_PLACEHOLDER = 'x'),
        h = new RegExp(c),
        y = new RegExp('^[' + $.VALID_PUNCTUATION + ']*(\\$\\d[' + $.VALID_PUNCTUATION + ']*)+$'),
        p = '[' + $.PLUS_CHARS + ']{0,1}[' + $.VALID_PUNCTUATION + $.VALID_DIGITS + ']*',
        m = new RegExp('^' + p + '$', 'i'),
        _ = (function () {
          function t(d, e) {
            !(function (t, d) {
              if (!(t instanceof d)) throw new TypeError('Cannot call a class as a function');
            })(this, t),
              (this.options = {}),
              (this.metadata = new r.default(e)),
              d && this.metadata.hasCountry(d) && (this.default_country = d),
              this.reset();
          }
          return (
            l(t, [
              {
                key: 'input',
                value: function (t) {
                  var d = (0, a.extract_formatted_phone_number)(t) || '';
                  return (
                    d || (t && t.indexOf('+') >= 0 && (d = '+')),
                    m.test(d) ? this.process_input((0, u.default)(d)) : this.current_output
                  );
                },
              },
              {
                key: 'process_input',
                value: function (t) {
                  if (
                    ('+' === t[0] &&
                      (this.parsed_input || ((this.parsed_input += '+'), this.reset_countriness()),
                      (t = t.slice(1))),
                    (this.parsed_input += t),
                    (this.national_number += t),
                    this.is_international())
                  )
                    if (this.countryCallingCode) this.country || this.determine_the_country();
                    else {
                      if (!this.national_number) return this.parsed_input;
                      if (!this.extract_country_calling_code()) return this.parsed_input;
                      this.initialize_phone_number_formats_for_this_country_calling_code(),
                        this.reset_format(),
                        this.determine_the_country();
                    }
                  else {
                    var d = this.national_prefix;
                    (this.national_number = this.national_prefix + this.national_number),
                      this.extract_national_prefix(),
                      this.national_prefix !== d &&
                        ((this.matching_formats = void 0), this.reset_format());
                  }
                  if (!this.national_number) return this.format_as_non_formatted_number();
                  this.match_formats_by_leading_digits();
                  var e = this.format_national_phone_number(t);
                  return e ? this.full_phone_number(e) : this.format_as_non_formatted_number();
                },
              },
              {
                key: 'format_as_non_formatted_number',
                value: function () {
                  return this.is_international() && this.countryCallingCode
                    ? '+' + this.countryCallingCode + this.national_number
                    : this.parsed_input;
                },
              },
              {
                key: 'format_national_phone_number',
                value: function (t) {
                  var d = void 0;
                  this.chosen_format && (d = this.format_next_national_number_digits(t));
                  var e = this.attempt_to_format_complete_phone_number();
                  return e || (this.choose_another_format() ? this.reformat_national_number() : d);
                },
              },
              {
                key: 'reset',
                value: function () {
                  return (
                    (this.parsed_input = ''),
                    (this.current_output = ''),
                    (this.national_prefix = ''),
                    (this.national_number = ''),
                    (this.carrierCode = ''),
                    this.reset_countriness(),
                    this.reset_format(),
                    this
                  );
                },
              },
              {
                key: 'reset_country',
                value: function () {
                  this.is_international()
                    ? (this.country = void 0)
                    : (this.country = this.default_country);
                },
              },
              {
                key: 'reset_countriness',
                value: function () {
                  this.reset_country(),
                    this.default_country && !this.is_international()
                      ? (this.metadata.country(this.default_country),
                        (this.countryCallingCode = this.metadata.countryCallingCode()),
                        this.initialize_phone_number_formats_for_this_country_calling_code())
                      : (this.metadata.country(void 0),
                        (this.countryCallingCode = void 0),
                        (this.available_formats = []),
                        (this.matching_formats = void 0));
                },
              },
              {
                key: 'reset_format',
                value: function () {
                  (this.chosen_format = void 0),
                    (this.template = void 0),
                    (this.partially_populated_template = void 0),
                    (this.last_match_position = -1);
                },
              },
              {
                key: 'reformat_national_number',
                value: function () {
                  return this.format_next_national_number_digits(this.national_number);
                },
              },
              {
                key: 'initialize_phone_number_formats_for_this_country_calling_code',
                value: function () {
                  (this.available_formats = this.metadata.formats().filter(function (t) {
                    return y.test(t.internationalFormat());
                  })),
                    (this.matching_formats = void 0);
                },
              },
              {
                key: 'match_formats_by_leading_digits',
                value: function () {
                  var t = this.national_number,
                    d = t.length - 3;
                  d < 0 && (d = 0);
                  var e =
                    (this.had_enough_leading_digits && this.matching_formats) ||
                    this.available_formats;
                  (this.had_enough_leading_digits = this.should_format()),
                    (this.matching_formats = e.filter(function (e) {
                      var r = e.leadingDigitsPatterns().length;
                      if (0 === r) return !0;
                      var n = Math.min(d, r - 1),
                        $ = e.leadingDigitsPatterns()[n];
                      return new RegExp('^(' + $ + ')').test(t);
                    })),
                    this.chosen_format &&
                      -1 === this.matching_formats.indexOf(this.chosen_format) &&
                      this.reset_format();
                },
              },
              {
                key: 'should_format',
                value: function () {
                  return this.national_number.length >= 3;
                },
              },
              {
                key: 'attempt_to_format_complete_phone_number',
                value: function () {
                  var t = this.matching_formats,
                    d = Array.isArray(t),
                    e = 0;
                  for (t = d ? t : t[Symbol.iterator](); ; ) {
                    var r;
                    if (d) {
                      if (e >= t.length) break;
                      r = t[e++];
                    } else {
                      if ((e = t.next()).done) break;
                      r = e.value;
                    }
                    var n = r;
                    if (
                      new RegExp('^(?:' + n.pattern() + ')$').test(this.national_number) &&
                      this.is_format_applicable(n)
                    ) {
                      this.reset_format(), (this.chosen_format = n);
                      var $ = (0, i.format_national_number_using_format)(
                        this.national_number,
                        n,
                        this.is_international(),
                        '' !== this.national_prefix,
                        this.metadata,
                      );
                      if (
                        (this.national_prefix && '1' === this.countryCallingCode && ($ = '1 ' + $),
                        this.create_formatting_template(n))
                      )
                        this.reformat_national_number();
                      else {
                        var a = this.full_phone_number($);
                        (this.template = a.replace(/[\d\+]/g, c)),
                          (this.partially_populated_template = a);
                      }
                      return $;
                    }
                  }
                },
              },
              {
                key: 'full_phone_number',
                value: function (t) {
                  return this.is_international() ? '+' + this.countryCallingCode + ' ' + t : t;
                },
              },
              {
                key: 'extract_country_calling_code',
                value: function () {
                  var t = (0, $.extractCountryCallingCode)(
                      this.parsed_input,
                      this.default_country,
                      this.metadata.metadata,
                    ),
                    d = t.countryCallingCode,
                    e = t.number;
                  if (d)
                    return (
                      (this.countryCallingCode = d),
                      (this.national_number = e),
                      this.metadata.chooseCountryByCountryCallingCode(d),
                      void 0 !== this.metadata.selectedCountry()
                    );
                },
              },
              {
                key: 'extract_national_prefix',
                value: function () {
                  if (((this.national_prefix = ''), this.metadata.selectedCountry())) {
                    var t = (0, a.strip_national_prefix_and_carrier_code)(
                        this.national_number,
                        this.metadata,
                      ),
                      d = t.number,
                      e = t.carrierCode;
                    if (
                      (e && (this.carrierCode = e),
                      (this.metadata.possibleLengths() &&
                        (!this.is_possible_number(this.national_number) ||
                          this.is_possible_number(d))) ||
                        !(0, $.matches_entirely)(
                          this.national_number,
                          this.metadata.nationalNumberPattern(),
                        ) ||
                        (0, $.matches_entirely)(d, this.metadata.nationalNumberPattern()))
                    )
                      return (
                        (this.national_prefix = this.national_number.slice(
                          0,
                          this.national_number.length - d.length,
                        )),
                        (this.national_number = d),
                        this.national_prefix
                      );
                  }
                },
              },
              {
                key: 'is_possible_number',
                value: function (t) {
                  switch ((0, o.check_number_length_for_type)(t, void 0, this.metadata)) {
                    case 'IS_POSSIBLE':
                      return !0;
                    default:
                      return !1;
                  }
                },
              },
              {
                key: 'choose_another_format',
                value: function () {
                  var t = this.matching_formats,
                    d = Array.isArray(t),
                    e = 0;
                  for (t = d ? t : t[Symbol.iterator](); ; ) {
                    var r;
                    if (d) {
                      if (e >= t.length) break;
                      r = t[e++];
                    } else {
                      if ((e = t.next()).done) break;
                      r = e.value;
                    }
                    var n = r;
                    if (this.chosen_format === n) return;
                    if (this.is_format_applicable(n) && this.create_formatting_template(n))
                      return (this.chosen_format = n), (this.last_match_position = -1), !0;
                  }
                  this.reset_country(), this.reset_format();
                },
              },
              {
                key: 'is_format_applicable',
                value: function (t) {
                  return (
                    !(
                      !this.is_international() &&
                      !this.national_prefix &&
                      t.nationalPrefixIsMandatoryWhenFormatting()
                    ) &&
                    !(
                      this.national_prefix &&
                      !t.usesNationalPrefix() &&
                      !t.nationalPrefixIsOptionalWhenFormatting()
                    )
                  );
                },
              },
              {
                key: 'create_formatting_template',
                value: function (t) {
                  if (!(t.pattern().indexOf('|') >= 0)) {
                    var d = this.get_template_for_phone_number_format_pattern(t);
                    if (d)
                      return (
                        (this.partially_populated_template = d),
                        this.is_international()
                          ? (this.template = c + C(c, this.countryCallingCode.length) + ' ' + d)
                          : (this.template = d.replace(/\d/g, c)),
                        this.template
                      );
                  }
                },
              },
              {
                key: 'get_template_for_phone_number_format_pattern',
                value: function (t) {
                  var d = t
                      .pattern()
                      .replace(/\[([^\[\]])*\]/g, '\\d')
                      .replace(/\d(?=[^,}][^,}])/g, '\\d'),
                    e = f.match(d)[0];
                  if (!(this.national_number.length > e.length)) {
                    var r = this.get_format_format(t),
                      n = new RegExp('^' + d + '$'),
                      $ = this.national_number.replace(/\d/g, '9');
                    return (
                      n.test($) && (e = $),
                      e.replace(new RegExp(d), r).replace(new RegExp('9', 'g'), c)
                    );
                  }
                },
              },
              {
                key: 'format_next_national_number_digits',
                value: function (t) {
                  var d = t.split(''),
                    e = Array.isArray(d),
                    r = 0;
                  for (d = e ? d : d[Symbol.iterator](); ; ) {
                    var n;
                    if (e) {
                      if (r >= d.length) break;
                      n = d[r++];
                    } else {
                      if ((r = d.next()).done) break;
                      n = r.value;
                    }
                    var $ = n;
                    if (
                      -1 ===
                      this.partially_populated_template
                        .slice(this.last_match_position + 1)
                        .search(h)
                    )
                      return (
                        (this.chosen_format = void 0),
                        (this.template = void 0),
                        void (this.partially_populated_template = void 0)
                      );
                    (this.last_match_position = this.partially_populated_template.search(h)),
                      (this.partially_populated_template =
                        this.partially_populated_template.replace(h, $));
                  }
                  return b(this.partially_populated_template, this.last_match_position + 1);
                },
              },
              {
                key: 'is_international',
                value: function () {
                  return this.parsed_input && '+' === this.parsed_input[0];
                },
              },
              {
                key: 'get_format_format',
                value: function (t) {
                  if (this.is_international())
                    return (0, i.changeInternationalFormatStyle)(t.internationalFormat());
                  if (t.nationalPrefixFormattingRule()) {
                    if (this.national_prefix || !t.usesNationalPrefix())
                      return t
                        .format()
                        .replace(i.FIRST_GROUP_PATTERN, t.nationalPrefixFormattingRule());
                  } else if ('1' === this.countryCallingCode && '1' === this.national_prefix)
                    return '1 ' + t.format();
                  return t.format();
                },
              },
              {
                key: 'determine_the_country',
                value: function () {
                  this.country = (0, a.find_country_code)(
                    this.countryCallingCode,
                    this.national_number,
                    this.metadata,
                  );
                },
              },
              {
                key: 'getNumber',
                value: function () {
                  if (this.countryCallingCode && this.national_number) {
                    var t = new n.default(
                      this.country || this.countryCallingCode,
                      this.national_number,
                      this.metadata.metadata,
                    );
                    return this.carrierCode && (t.carrierCode = this.carrierCode), t;
                  }
                },
              },
              {
                key: 'getNationalNumber',
                value: function () {
                  return this.national_number;
                },
              },
              {
                key: 'getTemplate',
                value: function () {
                  if (this.template) {
                    for (var t = -1, d = 0; d < this.parsed_input.length; )
                      (t = this.template.indexOf(c, t + 1)), d++;
                    return b(this.template, t + 1);
                  }
                },
              },
            ]),
            t
          );
        })();
      function v(t) {
        for (var d = [], e = 0; e < t.length; )
          '(' === t[e] ? d.push(e) : ')' === t[e] && d.pop(), e++;
        var r = 0,
          n = '';
        d.push(t.length);
        var $ = d,
          a = Array.isArray($),
          i = 0;
        for ($ = a ? $ : $[Symbol.iterator](); ; ) {
          var o;
          if (a) {
            if (i >= $.length) break;
            o = $[i++];
          } else {
            if ((i = $.next()).done) break;
            o = i.value;
          }
          var u = o;
          (n += t.slice(r, u)), (r = u + 1);
        }
        return n;
      }
      function b(t, d) {
        return ')' === t[d] && d++, v(t.slice(0, d));
      }
      function g(t, d) {
        var e = 0,
          r = d.split(''),
          n = Array.isArray(r),
          $ = 0;
        for (r = n ? r : r[Symbol.iterator](); ; ) {
          var a;
          if (n) {
            if ($ >= r.length) break;
            a = r[$++];
          } else {
            if (($ = r.next()).done) break;
            a = $.value;
          }
          a === t && e++;
        }
        return e;
      }
      function C(t, d) {
        if (d < 1) return '';
        for (var e = ''; d > 1; ) 1 & d && (e += t), (d >>= 1), (t += t);
        return e + t;
      }
      d.default = _;
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.isLatinLetter = function (t) {
          if (!$.test(t) && !i.test(t)) return !1;
          return o.test(t);
        }),
        (d.isInvalidPunctuationSymbol = function (t) {
          return '%' === t || a.test(t);
        });
      var r = '   ᠎ - \u2028\u2029  　',
        n =
          ((d.pZ = '[' + r + ']'),
          (d.PZ = '[^' + r + ']'),
          (d._pN =
            '0-9²³¹¼-¾٠-٩۰-۹߀-߉०-९০-৯৴-৹੦-੯૦-૯୦-୯୲-୷௦-௲౦-౯౸-౾೦-೯൦-൵๐-๙໐-໙༠-༳၀-၉႐-႙፩-፼ᛮ-ᛰ០-៩៰-៹᠐-᠙᥆-᥏᧐-᧚᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙⁰⁴-⁹₀-₉⅐-ↂↅ-↉①-⒛⓪-⓿❶-➓⳽〇〡-〩〸-〺㆒-㆕㈠-㈩㉈-㉏㉑-㉟㊀-㊉㊱-㊿꘠-꘩ꛦ-ꛯ꠰-꠵꣐-꣙꤀-꤉꧐-꧙꩐-꩙꯰-꯹０-９'),
          (d.pNd =
            '[0-9٠-٩۰-۹߀-߉०-९০-৯੦-੯૦-૯୦-୯௦-௯౦-౯೦-೯൦-൯๐-๙໐-໙༠-༩၀-၉႐-႙០-៩᠐-᠙᥆-᥏᧐-᧙᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙꘠-꘩꣐-꣙꤀-꤉꧐-꧙꩐-꩙꯰-꯹０-９]'),
          (d._pL =
            'A-Za-zªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々〆〱-〵〻〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛥꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ')),
        $ = new RegExp('[' + n + ']'),
        a = new RegExp('[$¢-¥֏؋৲৳৻૱௹฿៛₠-₹꠸﷼﹩＄￠￡￥￦]'),
        i = new RegExp(
          '[̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-ٰٟۖ-ۜ۟-۪ۤۧۨ-ܑۭܰ-݊ަ-ް߫-߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛ࣤ-ࣾऀ-ंऺ़ु-ै्॑-ॗॢॣঁ়ু-ৄ্ৢৣਁਂ਼ੁੂੇੈੋ-੍ੑੰੱੵઁં઼ુ-ૅેૈ્ૢૣଁ଼ିୁ-ୄ୍ୖୢୣஂீ்ా-ీె-ైొ-్ౕౖౢౣ಼ಿೆೌ್ೢೣു-ൄ്ൢൣ්ි-ුූัิ-ฺ็-๎ັິ-ູົຼ່-ໍཱ༹༘༙༵༷-ཾྀ-྄྆྇ྍ-ྗྙ-ྼ࿆ိ-ူဲ-့္်ွှၘၙၞ-ၠၱ-ၴႂႅႆႍႝ፝-፟ᜒ-᜔ᜲ-᜴ᝒᝓᝲᝳ឴឵ិ-ួំ៉-៓៝᠋-᠍ᢩᤠ-ᤢᤧᤨᤲ᤹-᤻ᨘᨗᩖᩘ-ᩞ᩠ᩢᩥ-ᩬᩳ-᩿᩼ᬀ-ᬃ᬴ᬶ-ᬺᬼᭂ᭫-᭳ᮀᮁᮢ-ᮥᮨᮩ᯦᮫ᯨᯩᯭᯯ-ᯱᰬ-ᰳᰶ᰷᳐-᳔᳒-᳢᳠-᳨᳭᳴᷀-ᷦ᷼-᷿⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〭꙯ꙴ-꙽ꚟ꛰꛱ꠂ꠆ꠋꠥꠦ꣄꣠-꣱ꤦ-꤭ꥇ-ꥑꦀ-ꦂ꦳ꦶ-ꦹꦼꨩ-ꨮꨱꨲꨵꨶꩃꩌꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫬꫭ꫶ꯥꯨ꯭ﬞ︀-️︠-︦]',
        ),
        o = new RegExp('[\0--ÿĀ-ſḀ-ỿƀ-ɏ̀-ͯ]');
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.LEAD_CLASS = void 0),
        (d.default = function (t, d, e, r) {
          if (!u.test(t) || s.test(t)) return;
          if ('POSSIBLE' !== r) {
            if (d > 0 && !i.test(t)) {
              var n = e[d - 1];
              if ((0, $.isInvalidPunctuationSymbol)(n) || (0, $.isLatinLetter)(n)) return !1;
            }
            var a = d + t.length;
            if (a < e.length) {
              var o = e[a];
              if ((0, $.isInvalidPunctuationSymbol)(o) || (0, $.isLatinLetter)(o)) return !1;
            }
          }
          return !0;
        });
      var r = e(0),
        n = e(6),
        $ = e(14),
        a = (d.LEAD_CLASS = '[(\\[（［' + r.PLUS_CHARS + ']'),
        i = new RegExp('^' + a),
        o = (0, n.limit)(0, 3),
        u = new RegExp(
          '^(?:[(\\[（［])?(?:[^(\\[（［)\\]）］]+[)\\]）］])?[^(\\[（［)\\]）］]+(?:[(\\[（［][^(\\[（［)\\]）］]+[)\\]）］])' +
            o +
            '[^(\\[（［)\\]）］]*$',
        ),
        s = /\d{1,5}-+\d{1,5}\s{0,4}\(\d{1,4}/;
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.default = function (t, d, e) {
          if (r.test(t)) return !1;
          if (n.test(t)) {
            var a = e.slice(d + t.length);
            if ($.test(a)) return !1;
          }
          return !0;
        });
      var r = /(?:(?:[0-3]?\d\/[01]?\d)|(?:[01]?\d\/[0-3]?\d))\/(?:[12]\d)?\d{2}/,
        n = /[12]\d{3}[-/]?[01]\d[-/]?[0-3]\d +[0-2]\d$/,
        $ = /^:[0-5]\d/;
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.default = function (t) {
          return (0, r.trimAfterFirstMatch)(n, t);
        });
      var r = e(6),
        n = /[\\/] *x/;
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.default = function (t, d) {
          if (!(d = new $.default(d)).hasCountry(t)) throw new Error('Unknown country: ' + t);
          return d.country(t).countryCallingCode();
        });
      var r,
        n = e(1),
        $ = (r = n) && r.__esModule ? r : { default: r };
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.getIDDPrefix = function (t, d) {
          var e = new $.default(d);
          if ((e.country(t), o.test(e.IDDPrefix()))) return e.IDDPrefix();
          return e.defaultIDDPrefix();
        }),
        (d.stripIDDPrefix = function (t, d, e) {
          if (!d) return;
          var r = new $.default(e);
          r.country(d);
          var n = new RegExp(r.IDDPrefix());
          if (0 !== t.search(n)) return;
          var a = (t = t.slice(t.match(n)[0].length)).match(i);
          if (a && null != a[1] && a[1].length > 0 && '0' === a[1]) return;
          return t;
        });
      var r,
        n = e(1),
        $ = (r = n) && r.__esModule ? r : { default: r },
        a = e(0);
      var i = new RegExp('([' + a.VALID_DIGITS + '])'),
        o = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.default = function (t, d, e) {
          e || ((e = d), (d = void 0));
          return new $.default(d, e).input(t);
        });
      var r,
        n = e(13),
        $ = (r = n) && r.__esModule ? r : { default: r };
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.default = function (t, d, e, r) {
          var $ = (0, n.sort_out_arguments)(t, d, e, r),
            i = $.text,
            o = $.options,
            u = $.metadata,
            s = new a.default(i, o, u);
          return (function (t, d, e) {
            d in t
              ? Object.defineProperty(t, d, {
                  value: e,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (t[d] = e);
            return t;
          })({}, Symbol.iterator, function () {
            return {
              next: function () {
                return s.hasNext() ? { done: !1, value: s.next() } : { done: !0 };
              },
            };
          });
        });
      var r,
        n = e(10),
        $ = e(9),
        a = (r = $) && r.__esModule ? r : { default: r };
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.containsMoreThanOneSlashInNationalNumber = u);
      a(e(2));
      var r = a(e(4)),
        n = e(0),
        $ = e(6);
      function a(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function i(t, d, e) {
        for (var r = 0; r < d.length - 1; r++) {
          var n = d.charAt(r);
          if ('x' === n || 'X' === n) {
            var $ = d.charAt(r + 1);
            if ('x' === $ || 'X' === $) {
              if ((r++, util.isNumberMatch(t, d.substring(r)) != MatchType.NSN_MATCH)) return !1;
            } else if (h(d.substring(r)) !== t.ext) return !1;
          }
        }
        return !0;
      }
      function o(t, d) {
        if ('FROM_DEFAULT_COUNTRY' != t.getCountryCodeSource()) return !0;
        var e = util.getRegionCodeForCountryCode(t.getCountryCode()),
          r = util.getMetadataForRegion(e);
        if (null == r) return !0;
        var n = util.getNationalSignificantNumber(t),
          $ = util.chooseFormattingPatternForNumber(r.numberFormats(), n);
        if ($ && $.getNationalPrefixFormattingRule().length > 0) {
          if ($.getNationalPrefixOptionalWhenFormatting()) return !0;
          if (PhoneNumberUtil.formattingRuleHasFirstGroupOnly($.getNationalPrefixFormattingRule()))
            return !0;
          var a = PhoneNumberUtil.normalizeDigitsOnly(t.getRawInput());
          return util.maybeStripNationalPrefixAndCarrierCode(a, r, null);
        }
        return !0;
      }
      function u(t, d) {
        var e = d.indexOf('/');
        if (e < 0) return !1;
        var r = d.indexOf('/', e + 1);
        return (
          !(r < 0) &&
          (!(
            t.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN ||
            t.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN
          ) ||
            PhoneNumberUtil.normalizeDigitsOnly(d.substring(0, e)) !== String(t.getCountryCode()) ||
            d.slice(r + 1).indexOf('/') >= 0)
        );
      }
      function s(t, d, e, r) {
        var n = normalizeDigits(d, !0),
          $ = l(e, t, null);
        if (r(e, t, n, $)) return !0;
        var a = MetadataManager.getAlternateFormatsForCountry(t.getCountryCode());
        if (a) {
          var i = a.numberFormats(),
            o = Array.isArray(i),
            u = 0;
          for (i = o ? i : i[Symbol.iterator](); ; ) {
            var s;
            if (o) {
              if (u >= i.length) break;
              s = i[u++];
            } else {
              if ((u = i.next()).done) break;
              s = u.value;
            }
            if (r(e, t, n, ($ = l(e, t, s)))) return !0;
          }
        }
        return !1;
      }
      function l(t, d, e) {
        if (e) {
          var r = util.getNationalSignificantNumber(d);
          return util.formatNsnUsingPattern(r, e, 'RFC3966', t).split('-');
        }
        var n = formatNumber(d, 'RFC3966', t),
          $ = n.indexOf(';');
        $ < 0 && ($ = n.length);
        var a = n.indexOf('-') + 1;
        return n.slice(a, $).split('-');
      }
      function f(t, d, e, r) {
        var n = e.split(NON_DIGITS_PATTERN),
          a = d.hasExtension() ? n.length - 2 : n.length - 1;
        if (1 == n.length || n[a].contains(util.getNationalSignificantNumber(d))) return !0;
        for (var i = r.length - 1; i > 0 && a >= 0; ) {
          if (n[a] !== r[i]) return !1;
          i--, a--;
        }
        return a >= 0 && (0, $.endsWith)(n[a], r[0]);
      }
      function c(t, d, e, r) {
        var n = 0;
        if (d.getCountryCodeSource() !== CountryCodeSource.FROM_DEFAULT_COUNTRY) {
          var a = String(d.getCountryCode());
          n = e.indexOf(a) + a.length();
        }
        for (var i = 0; i < r.length; i++) {
          if ((n = e.indexOf(r[i], n)) < 0) return !1;
          if (((n += r[i].length()), 0 == i && n < e.length())) {
            var o = util.getRegionCodeForCountryCode(d.getCountryCode());
            if (null != util.getNddPrefixForRegion(o, !0) && Character.isDigit(e.charAt(n))) {
              var u = util.getNationalSignificantNumber(d);
              return (0, $.startsWith)(e.slice(n - r[i].length), u);
            }
          }
        }
        return e.slice(n).contains(d.getExtension());
      }
      function h(t) {
        var d = '',
          e = t.split(''),
          r = Array.isArray(e),
          $ = 0;
        for (e = r ? e : e[Symbol.iterator](); ; ) {
          var a;
          if (r) {
            if ($ >= e.length) break;
            a = e[$++];
          } else {
            if (($ = e.next()).done) break;
            a = $.value;
          }
          var i = a,
            o = (0, n.parseDigit)(i);
          o && (d += o);
        }
        return d;
      }
      d.default = {
        POSSIBLE: function (t, d, e) {
          return !0;
        },
        VALID: function (t, d, e) {
          return !(!(0, r.default)(t, e) || !i(t, d.toString(), e));
        },
        STRICT_GROUPING: function (t, d, e) {
          var n = d.toString();
          return !(!(0, r.default)(t, e) || !i(t, n, e) || u(t, n) || !o(t, e)) && s(t, d, e, c);
        },
        EXACT_GROUPING: function (t, d, e) {
          var n = d.toString();
          return !(!(0, r.default)(t, e) || !i(t, n, e) || u(t, n) || !o(t, e)) && s(t, d, e, f);
        },
      };
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.default = function (t, d, e, r) {
          var $ = (0, n.sort_out_arguments)(t, d, e, r),
            i = $.text,
            o = $.options,
            u = $.metadata,
            s = new a.default(i, o, u),
            l = [];
          for (; s.hasNext(); ) l.push(s.next());
          return l;
        });
      var r,
        n = e(10),
        $ = e(9),
        a = (r = $) && r.__esModule ? r : { default: r };
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.default = function (t, d, e) {
          if ('string' != typeof t) throw new TypeError('number must be a string');
          if ('string' != typeof d) throw new TypeError('country must be a string');
          var r = (0, n.sort_out_arguments)(t, d, e),
            $ = r.input,
            i = r.metadata;
          return $.country === d && (0, a.default)($, i.metadata);
        });
      var r,
        n = e(3),
        $ = e(4),
        a = (r = $) && r.__esModule ? r : { default: r };
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.default = function (t, d, e) {
          return new $.default(t, d[t], e);
        });
      var r,
        n = e(5),
        $ = (r = n) && r.__esModule ? r : { default: r };
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 });
      var r =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                'function' == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? 'symbol'
                : typeof t;
            };
      d.default = function (t, d, e) {
        i(d) && ((e = d), (d = void 0));
        return (0, n.default)(t, { defaultCountry: d, v2: !0 }, e);
      };
      $(e(5));
      var n = $(e(2));
      function $(t) {
        return t && t.__esModule ? t : { default: t };
      }
      var a =
        'function' == typeof Symbol && 'symbol' === r(Symbol.iterator)
          ? function (t) {
              return void 0 === t ? 'undefined' : r(t);
            }
          : function (t) {
              return t &&
                'function' == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? 'symbol'
                : void 0 === t
                ? 'undefined'
                : r(t);
            };
      var i = function (t) {
        return 'object' === (void 0 === t ? 'undefined' : a(t));
      };
    },
    function (t) {
      t.exports = {
        version: '1.6.8',
        country_calling_codes: {
          1: [
            'US',
            'AG',
            'AI',
            'AS',
            'BB',
            'BM',
            'BS',
            'CA',
            'DM',
            'DO',
            'GD',
            'GU',
            'JM',
            'KN',
            'KY',
            'LC',
            'MP',
            'MS',
            'PR',
            'SX',
            'TC',
            'TT',
            'VC',
            'VG',
            'VI',
          ],
          7: ['RU', 'KZ'],
          20: ['EG'],
          27: ['ZA'],
          30: ['GR'],
          31: ['NL'],
          32: ['BE'],
          33: ['FR'],
          34: ['ES'],
          36: ['HU'],
          39: ['IT', 'VA'],
          40: ['RO'],
          41: ['CH'],
          43: ['AT'],
          44: ['GB', 'GG', 'IM', 'JE'],
          45: ['DK'],
          46: ['SE'],
          47: ['NO', 'SJ'],
          48: ['PL'],
          49: ['DE'],
          51: ['PE'],
          52: ['MX'],
          53: ['CU'],
          54: ['AR'],
          55: ['BR'],
          56: ['CL'],
          57: ['CO'],
          58: ['VE'],
          60: ['MY'],
          61: ['AU', 'CC', 'CX'],
          62: ['ID'],
          63: ['PH'],
          64: ['NZ'],
          65: ['SG'],
          66: ['TH'],
          81: ['JP'],
          82: ['KR'],
          84: ['VN'],
          86: ['CN'],
          90: ['TR'],
          91: ['IN'],
          92: ['PK'],
          93: ['AF'],
          94: ['LK'],
          95: ['MM'],
          98: ['IR'],
          211: ['SS'],
          212: ['MA', 'EH'],
          213: ['DZ'],
          216: ['TN'],
          218: ['LY'],
          220: ['GM'],
          221: ['SN'],
          222: ['MR'],
          223: ['ML'],
          224: ['GN'],
          225: ['CI'],
          226: ['BF'],
          227: ['NE'],
          228: ['TG'],
          229: ['BJ'],
          230: ['MU'],
          231: ['LR'],
          232: ['SL'],
          233: ['GH'],
          234: ['NG'],
          235: ['TD'],
          236: ['CF'],
          237: ['CM'],
          238: ['CV'],
          239: ['ST'],
          240: ['GQ'],
          241: ['GA'],
          242: ['CG'],
          243: ['CD'],
          244: ['AO'],
          245: ['GW'],
          246: ['IO'],
          247: ['AC'],
          248: ['SC'],
          249: ['SD'],
          250: ['RW'],
          251: ['ET'],
          252: ['SO'],
          253: ['DJ'],
          254: ['KE'],
          255: ['TZ'],
          256: ['UG'],
          257: ['BI'],
          258: ['MZ'],
          260: ['ZM'],
          261: ['MG'],
          262: ['RE', 'YT'],
          263: ['ZW'],
          264: ['NA'],
          265: ['MW'],
          266: ['LS'],
          267: ['BW'],
          268: ['SZ'],
          269: ['KM'],
          290: ['SH', 'TA'],
          291: ['ER'],
          297: ['AW'],
          298: ['FO'],
          299: ['GL'],
          350: ['GI'],
          351: ['PT'],
          352: ['LU'],
          353: ['IE'],
          354: ['IS'],
          355: ['AL'],
          356: ['MT'],
          357: ['CY'],
          358: ['FI', 'AX'],
          359: ['BG'],
          370: ['LT'],
          371: ['LV'],
          372: ['EE'],
          373: ['MD'],
          374: ['AM'],
          375: ['BY'],
          376: ['AD'],
          377: ['MC'],
          378: ['SM'],
          380: ['UA'],
          381: ['RS'],
          382: ['ME'],
          383: ['XK'],
          385: ['HR'],
          386: ['SI'],
          387: ['BA'],
          389: ['MK'],
          420: ['CZ'],
          421: ['SK'],
          423: ['LI'],
          500: ['FK'],
          501: ['BZ'],
          502: ['GT'],
          503: ['SV'],
          504: ['HN'],
          505: ['NI'],
          506: ['CR'],
          507: ['PA'],
          508: ['PM'],
          509: ['HT'],
          590: ['GP', 'BL', 'MF'],
          591: ['BO'],
          592: ['GY'],
          593: ['EC'],
          594: ['GF'],
          595: ['PY'],
          596: ['MQ'],
          597: ['SR'],
          598: ['UY'],
          599: ['CW', 'BQ'],
          670: ['TL'],
          672: ['NF'],
          673: ['BN'],
          674: ['NR'],
          675: ['PG'],
          676: ['TO'],
          677: ['SB'],
          678: ['VU'],
          679: ['FJ'],
          680: ['PW'],
          681: ['WF'],
          682: ['CK'],
          683: ['NU'],
          685: ['WS'],
          686: ['KI'],
          687: ['NC'],
          688: ['TV'],
          689: ['PF'],
          690: ['TK'],
          691: ['FM'],
          692: ['MH'],
          800: ['001'],
          808: ['001'],
          850: ['KP'],
          852: ['HK'],
          853: ['MO'],
          855: ['KH'],
          856: ['LA'],
          870: ['001'],
          878: ['001'],
          880: ['BD'],
          881: ['001'],
          882: ['001'],
          883: ['001'],
          886: ['TW'],
          888: ['001'],
          960: ['MV'],
          961: ['LB'],
          962: ['JO'],
          963: ['SY'],
          964: ['IQ'],
          965: ['KW'],
          966: ['SA'],
          967: ['YE'],
          968: ['OM'],
          970: ['PS'],
          971: ['AE'],
          972: ['IL'],
          973: ['BH'],
          974: ['QA'],
          975: ['BT'],
          976: ['MN'],
          977: ['NP'],
          979: ['001'],
          992: ['TJ'],
          993: ['TM'],
          994: ['AZ'],
          995: ['GE'],
          996: ['KG'],
          998: ['UZ'],
        },
        countries: {
          AC: ['247', '00', '(?:[01589]\\d|[46])\\d{4}', [5, 6]],
          AD: [
            '376',
            '00',
            '(?:1|6\\d)\\d{7}|[136-9]\\d{5}',
            [6, 8, 9],
            [
              ['(\\d{3})(\\d{3})', '$1 $2', ['[136-9]']],
              ['(\\d{4})(\\d{4})', '$1 $2', ['1']],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['6']],
            ],
          ],
          AE: [
            '971',
            '00',
            '(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}',
            [5, 6, 7, 8, 9, 10, 11, 12],
            [
              ['(\\d{3})(\\d{2,9})', '$1 $2', ['[68]00', '600[25]|800']],
              ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['[236]|[479][2-8]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['5'], '0$1'],
              ['(\\d{3})(\\d)(\\d{5})', '$1 $2 $3', ['[479]']],
            ],
            '0',
          ],
          AF: [
            '93',
            '00',
            '[2-7]\\d{8}',
            [9],
            [['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[2-7]'], '0$1']],
            '0',
          ],
          AG: ['1', '011', '(?:268|[58]\\d\\d|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '268'],
          AI: ['1', '011', '(?:264|[58]\\d\\d|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '264'],
          AL: [
            '355',
            '00',
            '(?:(?:[2-58]|6\\d)\\d\\d|700)\\d{5}|(?:8\\d{2,3}|900)\\d{3}',
            [6, 7, 8, 9],
            [
              ['(\\d{3})(\\d{3,4})', '$1 $2', ['80[08]|900', '80(?:0|8[1-9])|900[1-9]'], '0$1'],
              ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['4[2-6]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['[2358][2-5]|4'], '0$1'],
              ['(\\d{3})(\\d{5})', '$1 $2', ['[23578]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['6'], '0$1'],
            ],
            '0',
          ],
          AM: [
            '374',
            '00',
            '(?:[1-489]\\d|55|60|77)\\d{6}',
            [8],
            [
              ['(\\d{2})(\\d{6})', '$1 $2', ['1|47'], '(0$1)'],
              ['(\\d{3})(\\d{5})', '$1 $2', ['[23]'], '(0$1)'],
              ['(\\d{2})(\\d{6})', '$1 $2', ['[4-7]|88|9[13-9]'], '0$1'],
              ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['[89]'], '0 $1'],
            ],
            '0',
          ],
          AO: [
            '244',
            '00',
            '[29]\\d{8}',
            [9],
            [['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[29]']]],
          ],
          AR: [
            '54',
            '00',
            '(?:11|(?:[2368]|9\\d)\\d)\\d{8}',
            [10, 11],
            [
              ['([68]\\d{2})(\\d{3})(\\d{4})', '$1-$2-$3', ['[68]']],
              ['(9)(11)(\\d{4})(\\d{4})', '$2 15-$3-$4', ['911'], 0, 0, '$1 $2 $3-$4'],
              [
                '(9)(\\d{3})(\\d{3})(\\d{4})',
                '$2 15-$3-$4',
                [
                  '9(?:2[2-4689]|3[3-8])',
                  '9(?:2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578]))',
                  '9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))',
                  '9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))',
                ],
                0,
                0,
                '$1 $2 $3-$4',
              ],
              ['(9)(\\d{4})(\\d{2})(\\d{4})', '$2 15-$3-$4', ['9[23]'], 0, 0, '$1 $2 $3-$4'],
              ['(11)(\\d{4})(\\d{4})', '$1 $2-$3', ['11'], 0, 1],
              [
                '(\\d{3})(\\d{3})(\\d{4})',
                '$1 $2-$3',
                [
                  '2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578])',
                  '2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))',
                  '2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))',
                ],
                0,
                1,
              ],
              ['(\\d{4})(\\d{2})(\\d{4})', '$1 $2-$3', ['[23]'], 0, 1],
            ],
            '0',
            '0$1',
            '0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))?15)?',
            '9$1',
          ],
          AS: ['1', '011', '(?:[58]\\d\\d|684|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '684'],
          AT: [
            '43',
            '00',
            '[1-35-9]\\d{8,12}|4(?:[0-24-9]\\d{4,11}|3(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7}))|[1-35-8]\\d{7}|[1-35-7]\\d{6}|[135-7]\\d{5}|[15]\\d{4}|1\\d{3}',
            [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
            [
              ['(\\d)(\\d{3,12})', '$1 $2', ['1(?:11|[2-9])'], '0$1'],
              ['(\\d{3})(\\d{2})', '$1 $2', ['517'], '0$1'],
              ['(\\d{2})(\\d{3,5})', '$1 $2', ['5[079]'], '0$1'],
              [
                '(\\d{3})(\\d{3,10})',
                '$1 $2',
                ['(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]'],
                '0$1',
              ],
              ['(\\d{4})(\\d{3,9})', '$1 $2', ['[2-467]|5[2-6]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['5'], '0$1'],
              ['(\\d{2})(\\d{4})(\\d{4,7})', '$1 $2 $3', ['5'], '0$1'],
            ],
            '0',
          ],
          AU: [
            '61',
            '001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011',
            '1\\d{4,9}|(?:[2-478]\\d\\d|550)\\d{6}',
            [5, 6, 7, 8, 9, 10],
            [
              ['(\\d{2})(\\d{3,4})', '$1 $2', ['16'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{2,4})', '$1 $2 $3', ['16'], '0$1'],
              ['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['[2378]'], '(0$1)'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['14|[45]'], '0$1'],
              ['(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3', ['1(?:30|[89])']],
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
              [
                '(?:[237]\\d{5}|8(?:51(?:0(?:0[03-9]|[1247]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-6])|1(?:1[69]|[23]\\d|4[0-4]))|(?:[6-8]\\d{3}|9(?:[02-9]\\d\\d|1(?:[0-57-9]\\d|6[0135-9])))\\d))\\d{3}',
                [9],
              ],
              ['4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[0-2457-9]|9[017-9])\\d{6}', [9]],
              ['180(?:0\\d{3}|2)\\d{3}', [7, 10]],
              ['190[0-26]\\d{6}', [10]],
              0,
              0,
              0,
              ['16\\d{3,7}', [5, 6, 7, 8, 9]],
              ['(?:14(?:5\\d|71)|550\\d)\\d{5}', [9]],
              ['13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}', [6, 8, 10]],
            ],
            '0011',
          ],
          AW: [
            '297',
            '00',
            '(?:[25-79]\\d\\d|800)\\d{4}',
            [7],
            [['(\\d{3})(\\d{4})', '$1 $2', ['[25-9]']]],
          ],
          AX: [
            '358',
            '00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))',
            '(?:(?:[1247]\\d|3[0-46-9]|[56]0)\\d\\d|800)\\d{4,6}|(?:[1-47]\\d|50)\\d{4,5}|2\\d{4}',
            [5, 6, 7, 8, 9, 10],
            0,
            '0',
            0,
            0,
            0,
            0,
            '18',
            0,
            '00',
          ],
          AZ: [
            '994',
            '00',
            '(?:(?:(?:[12457]\\d|60|88)\\d|365)\\d{3}|900200)\\d{3}',
            [9],
            [
              [
                '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                '$1 $2 $3 $4',
                ['[12]|365', '[12]|365', '[12]|365(?:[0-46-9]|5[0-35-9])'],
                '(0$1)',
              ],
              ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['9'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[3-8]'], '0$1'],
            ],
            '0',
          ],
          BA: [
            '387',
            '00',
            '(?:[3589]\\d|49|6\\d\\d?|70)\\d{6}',
            [8, 9],
            [
              ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2-$3', ['[3-5]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['6[1-356]|[7-9]'], '0$1'],
              ['(\\d{2})(\\d{2})(\\d{2})(\\d{3})', '$1 $2 $3 $4', ['6'], '0$1'],
            ],
            '0',
          ],
          BB: ['1', '011', '(?:246|[58]\\d\\d|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '246'],
          BD: [
            '880',
            '00',
            '[13469]\\d{9}|8[0-79]\\d{7,8}|[2-7]\\d{8}|[2-9]\\d{7}|[3-689]\\d{6}|[57-9]\\d{5}',
            [6, 7, 8, 9, 10],
            [
              ['(\\d{2})(\\d{4,6})', '$1-$2', ['31[5-7]|[459]1'], '0$1'],
              [
                '(\\d{3})(\\d{3,7})',
                '$1-$2',
                [
                  '3(?:[2-5]1|[67]|8[013-9])|4(?:[235]1|4[01346-9]|6[168]|7|[89][18])|5(?:[2-578]1|6[128]|9)|6(?:[0389]1|28|4[14]|5|6[01346-9])|7(?:[2-589]|61)|8(?:0[014-9]|[12]|[3-7]1)|9(?:[24]1|[358])',
                ],
                '0$1',
              ],
              ['(\\d{4})(\\d{3,6})', '$1-$2', ['[13-9]'], '0$1'],
              ['(\\d)(\\d{7,8})', '$1-$2', ['2'], '0$1'],
            ],
            '0',
          ],
          BE: [
            '32',
            '00',
            '4\\d{8}|[1-9]\\d{7}',
            [8, 9],
            [
              ['(\\d)(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[23]|4[23]|9[2-4]'], '0$1'],
              [
                '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                '$1 $2 $3 $4',
                ['[15-7]|8(?:0[2-8]|[1-79])'],
                '0$1',
              ],
              ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['[89]'], '0$1'],
              ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['4'], '0$1'],
            ],
            '0',
          ],
          BF: [
            '226',
            '00',
            '[25-7]\\d{7}',
            [8],
            [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[25-7]']]],
          ],
          BG: [
            '359',
            '00',
            '[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}',
            [6, 7, 8, 9],
            [
              ['(\\d)(\\d)(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['2'], '0$1'],
              ['(\\d{3})(\\d{4})', '$1 $2', ['43[1-6]|70[1-9]'], '0$1'],
              ['(\\d)(\\d{3})(\\d{3,4})', '$1 $2 $3', ['2'], '0$1'],
              [
                '(\\d{2})(\\d{3})(\\d{2,3})',
                '$1 $2 $3',
                ['[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]'],
                '0$1',
              ],
              ['(\\d{3})(\\d{3})(\\d{2})', '$1 $2 $3', ['43[1-7]|70[1-9]'], '0$1'],
              ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['7|80'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[48]|9[08]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['9'], '0$1'],
            ],
            '0',
          ],
          BH: [
            '973',
            '00',
            '[136-9]\\d{7}',
            [8],
            [['(\\d{4})(\\d{4})', '$1 $2', ['[1367]|8[047]|9[014578]']]],
          ],
          BI: [
            '257',
            '00',
            '(?:[267]\\d|31)\\d{6}',
            [8],
            [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[23]|6[189]|7[125-9]']]],
          ],
          BJ: [
            '229',
            '00',
            '[2689]\\d{7}',
            [8],
            [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[2689]']]],
          ],
          BL: [
            '590',
            '00',
            '(?:590|69\\d)\\d{6}',
            [9],
            0,
            '0',
            0,
            0,
            0,
            0,
            0,
            [['590(?:2[7-9]|5[12]|87)\\d{4}'], ['69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}']],
          ],
          BM: ['1', '011', '(?:441|[58]\\d\\d|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '441'],
          BN: ['673', '00', '[2-578]\\d{6}', [7], [['(\\d{3})(\\d{4})', '$1 $2', ['[2-578]']]]],
          BO: [
            '591',
            '00(?:1\\d)?',
            '(?:[2-467]\\d{3}|80017)\\d{4}',
            [8, 9],
            [
              ['(\\d)(\\d{7})', '$1 $2', ['[2-4]']],
              ['(\\d{8})', '$1', ['[67]']],
              ['(\\d{3})(\\d{2})(\\d{4})', '$1 $2 $3', ['8']],
            ],
            '0',
            0,
            '0(1\\d)?',
          ],
          BQ: ['599', '00', '(?:[34]1|7\\d)\\d{5}', [7], 0, 0, 0, 0, 0, 0, '[347]'],
          BR: [
            '55',
            '00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)',
            '(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}',
            [8, 9, 10, 11],
            [
              ['(\\d{4})(\\d{4})', '$1-$2', ['300|4(?:0[02]|37)', '300|4(?:0(?:0|20)|370)']],
              ['([3589]00)(\\d{2,3})(\\d{4})', '$1 $2 $3', ['[3589]00'], '0$1'],
              ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2-$3', ['[1-9][1-9]'], '($1)'],
              ['(\\d{2})(\\d{5})(\\d{4})', '$1 $2-$3', ['[1-9][1-9]9'], '($1)'],
            ],
            '0',
            0,
            '0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?',
            '$2',
          ],
          BS: ['1', '011', '(?:242|[58]\\d\\d|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '242'],
          BT: [
            '975',
            '00',
            '[17]\\d{7}|[2-8]\\d{6}',
            [7, 8],
            [
              ['(\\d)(\\d{3})(\\d{3})', '$1 $2 $3', ['[23568]|4[5-7]|7[246]']],
              ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['1[67]|7']],
            ],
          ],
          BW: [
            '267',
            '00',
            '(?:(?:[2-6]|7\\d)\\d|90)\\d{5}',
            [7, 8],
            [
              ['(\\d{3})(\\d{4})', '$1 $2', ['[2-6]']],
              ['(\\d{2})(\\d{5})', '$1 $2', ['90']],
              ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['7']],
            ],
          ],
          BY: [
            '375',
            '810',
            '(?:(?:[12]|8[0-7]\\d)\\d|33|44|902)\\d{7}|8(?:[05-79]\\d|1[0-489])\\d{7}|8[0-79]\\d{5,7}|8\\d{5}',
            [6, 7, 8, 9, 10, 11],
            [
              ['(\\d{3})(\\d{3})', '$1 $2', ['800'], '8 $1'],
              ['(\\d{3})(\\d{2})(\\d{2,4})', '$1 $2 $3', ['800'], '8 $1'],
              [
                '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                '$1 $2-$3-$4',
                [
                  '1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])',
                  '1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])',
                ],
                '8 0$1',
              ],
              [
                '(\\d{4})(\\d{2})(\\d{3})',
                '$1 $2-$3',
                ['1(?:[56]|7[179])|2[1-3]', '1(?:[56]|7(?:1[3-9]|7|9[2-7]))|2[1-3]'],
                '8 0$1',
              ],
              ['(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1 $2-$3-$4', ['[1-4]'], '8 0$1'],
              ['(\\d{3})(\\d{3,4})(\\d{4})', '$1 $2 $3', ['[89]'], '8 $1'],
            ],
            '8',
            0,
            '0|80?',
            0,
            0,
            0,
            0,
            '8~10',
          ],
          BZ: [
            '501',
            '00',
            '(?:0800\\d|[2-8])\\d{6}',
            [7, 11],
            [
              ['(\\d{3})(\\d{4})', '$1-$2', ['[2-8]']],
              ['(\\d)(\\d{3})(\\d{4})(\\d{3})', '$1-$2-$3-$4', ['0']],
            ],
          ],
          CA: [
            '1',
            '011',
            '(?:[2-8]\\d|90)\\d{8}',
            [10],
            0,
            '1',
            0,
            0,
            0,
            0,
            0,
            [
              [
                '(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}',
              ],
              [''],
              ['8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'],
              ['900[2-9]\\d{6}'],
              ['(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}'],
              0,
              0,
              0,
              ['600[2-9]\\d{6}'],
            ],
          ],
          CC: [
            '61',
            '001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011',
            '1\\d{5,9}|(?:[48]\\d\\d|550)\\d{6}',
            [6, 7, 8, 9, 10],
            0,
            '0',
            0,
            '0|([59]\\d{7})$',
            '8$1',
            0,
            0,
            [
              [
                '8(?:51(?:0(?:02|31|60)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}',
                [9],
              ],
              ['4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[0-2457-9]|9[017-9])\\d{6}', [9]],
              ['180(?:0\\d{3}|2)\\d{3}', [7, 10]],
              ['190[0-26]\\d{6}', [10]],
              0,
              0,
              0,
              0,
              ['(?:14(?:5\\d|71)|550\\d)\\d{5}', [9]],
              ['13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}', [6, 8, 10]],
            ],
            '0011',
          ],
          CD: [
            '243',
            '00',
            '[189]\\d{8}|[1-68]\\d{6}',
            [7, 9],
            [
              ['(\\d{2})(\\d{2})(\\d{3})', '$1 $2 $3', ['88'], '0$1'],
              ['(\\d{2})(\\d{5})', '$1 $2', ['[1-6]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['1'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[89]'], '0$1'],
            ],
            '0',
          ],
          CF: [
            '236',
            '00',
            '(?:[27]\\d{3}|8776)\\d{4}',
            [8],
            [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[278]']]],
          ],
          CG: [
            '242',
            '00',
            '(?:(?:0\\d|80)\\d|222)\\d{6}',
            [9],
            [
              ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['801']],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[02]']],
              ['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['8']],
            ],
          ],
          CH: [
            '41',
            '00',
            '8\\d{11}|[2-9]\\d{8}',
            [9],
            [
              ['(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[2-7]|[89]1'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['8[047]|9'], '0$1'],
              ['(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4 $5', ['8'], '0$1'],
            ],
            '0',
          ],
          CI: [
            '225',
            '00',
            '[02-8]\\d{7}',
            [8],
            [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[02-8]']]],
          ],
          CK: ['682', '00', '[2-8]\\d{4}', [5], [['(\\d{2})(\\d{3})', '$1 $2', ['[2-8]']]]],
          CL: [
            '56',
            '(?:0|1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))0',
            '(?:1230|[2-57-9]\\d|6\\d{1,3})\\d{7}',
            [9, 10, 11],
            [
              ['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['2(?:2|32)', '2(?:2|32[0-46-8])'], '($1)'],
              [
                '(\\d{2})(\\d{3})(\\d{4})',
                '$1 $2 $3',
                ['3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])'],
                '($1)',
              ],
              ['(\\d{5})(\\d{4})', '$1 $2', ['2'], '($1)'],
              ['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['9[2-9]']],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['44']],
              ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[68]00']],
              ['(\\d{3})(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3 $4', ['600']],
              ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['1']],
            ],
          ],
          CM: [
            '237',
            '00',
            '(?:[26]\\d\\d|88)\\d{6}',
            [8, 9],
            [
              ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['88']],
              ['(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4 $5', ['[26]']],
            ],
          ],
          CN: [
            '86',
            '(?:1(?:[12]\\d{3}|79\\d{2}|9[0-7]\\d{2}))?00',
            '(?:(?:(?:1[03-68]|2\\d)\\d\\d|[3-79])\\d|8[0-57-9])\\d{7}|[1-579]\\d{10}|8[0-57-9]\\d{8,9}|[1-79]\\d{9}|[1-9]\\d{7}|[12]\\d{6}',
            [7, 8, 9, 10, 11, 12],
            [
              ['([48]00)(\\d{3})(\\d{4})', '$1 $2 $3', ['[48]00']],
              [
                '(\\d{2})(\\d{5,6})',
                '$1 $2',
                ['(?:10|2\\d)[19]', '(?:10|2\\d)(?:10|9[56])', '(?:10|2\\d)(?:100|9[56])'],
                '0$1',
              ],
              [
                '(\\d{3})(\\d{5,6})',
                '$1 $2',
                ['[3-9]', '[3-9]\\d\\d[19]', '[3-9]\\d\\d(?:10|9[56])'],
                '0$1',
              ],
              ['(21)(\\d{4})(\\d{4,6})', '$1 $2 $3', ['21'], '0$1', 1],
              [
                '([12]\\d)(\\d{4})(\\d{4})',
                '$1 $2 $3',
                ['10[1-9]|2[02-9]', '10[1-9]|2[02-9]', '10(?:[1-79]|8(?:0[1-9]|[1-9]))|2[02-9]'],
                '0$1',
                1,
              ],
              [
                '(\\d{3})(\\d{3})(\\d{4})',
                '$1 $2 $3',
                [
                  '3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[47-9]|7|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])',
                ],
                '0$1',
                1,
              ],
              [
                '(\\d{3})(\\d{4})(\\d{4})',
                '$1 $2 $3',
                [
                  '3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[457]|6[09])|8(?:[57]1|98)',
                ],
                '0$1',
                1,
              ],
              ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['807', '8078'], '0$1', 1],
              ['(\\d{3})(\\d{4})(\\d{4})', '$1 $2 $3', ['1(?:[3-57-9]|6[267])']],
              ['(10800)(\\d{3})(\\d{4})', '$1 $2 $3', ['108', '1080', '10800']],
              ['(\\d{3})(\\d{7,8})', '$1 $2', ['950']],
            ],
            '0',
            0,
            '0|(1(?:[12]\\d{3}|79\\d{2}|9[0-7]\\d{2}))',
            0,
            0,
            0,
            0,
            '00',
          ],
          CO: [
            '57',
            '00(?:4(?:[14]4|56)|[579])',
            '(?:1\\d|3)\\d{9}|[124-8]\\d{7}',
            [8, 10, 11],
            [
              ['(\\d)(\\d{7})', '$1 $2', ['1(?:[2-79]|8[2-9])|[24-8]'], '($1)'],
              ['(\\d{3})(\\d{7})', '$1 $2', ['3']],
              [
                '(\\d)(\\d{3})(\\d{7})',
                '$1-$2-$3',
                ['1(?:80|9)', '1(?:800|9)'],
                '0$1',
                0,
                '$1 $2 $3',
              ],
            ],
            '0',
            0,
            '0([3579]|4(?:[14]4|56))?',
          ],
          CR: [
            '506',
            '00',
            '(?:8\\d|90)\\d{8}|[24-8]\\d{7}',
            [8, 10],
            [
              ['(\\d{4})(\\d{4})', '$1 $2', ['[24-7]|8[3-9]']],
              ['(\\d{3})(\\d{3})(\\d{4})', '$1-$2-$3', ['[89]']],
            ],
            0,
            0,
            '(19(?:0[0-2468]|1[09]|20|66|77|99))',
          ],
          CU: [
            '53',
            '119',
            '[2-57]\\d{7}|[2-47]\\d{6}|[34]\\d{5}',
            [6, 7, 8],
            [
              ['(\\d{2})(\\d{4,6})', '$1 $2', ['[2-4]'], '(0$1)'],
              ['(\\d)(\\d{6,7})', '$1 $2', ['7'], '(0$1)'],
              ['(\\d)(\\d{7})', '$1 $2', ['5'], '0$1'],
            ],
            '0',
          ],
          CV: [
            '238',
            '0',
            '[2-59]\\d{6}',
            [7],
            [['(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3', ['[2-59]']]],
          ],
          CW: [
            '599',
            '00',
            '(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}',
            [7, 8],
            [
              ['(\\d{3})(\\d{4})', '$1 $2', ['[3467]']],
              ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['9[4-8]']],
            ],
            0,
            0,
            0,
            0,
            0,
            '[69]',
          ],
          CX: [
            '61',
            '001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011',
            '1\\d{5,9}|(?:[48]\\d\\d|550)\\d{6}',
            [6, 7, 8, 9, 10],
            0,
            '0',
            0,
            '0|([59]\\d{7})$',
            '8$1',
            0,
            0,
            [
              [
                '8(?:51(?:0(?:01|30|59)|117)|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}',
                [9],
              ],
              ['4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[0-2457-9]|9[017-9])\\d{6}', [9]],
              ['180(?:0\\d{3}|2)\\d{3}', [7, 10]],
              ['190[0-26]\\d{6}', [10]],
              0,
              0,
              0,
              0,
              ['(?:14(?:5\\d|71)|550\\d)\\d{5}', [9]],
              ['13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}', [6, 8, 10]],
            ],
            '0011',
          ],
          CY: [
            '357',
            '00',
            '(?:[279]\\d|[58]0)\\d{6}',
            [8],
            [['(\\d{2})(\\d{6})', '$1 $2', ['[257-9]']]],
          ],
          CZ: [
            '420',
            '00',
            '(?:[2-578]\\d|60|9\\d{1,4})\\d{7}',
            [9],
            [
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[2-8]|9[015-7]']],
              ['(\\d{2})(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['9[36]']],
              ['(\\d{3})(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['96']],
            ],
          ],
          DE: [
            '49',
            '00',
            '(?:1|[235-9]\\d{11}|4(?:[0-8]\\d{2,10}|9(?:[05]\\d{7}|[46][1-8]\\d{2,6})))\\d{3}|[1-35-9]\\d{6,13}|49(?:(?:[0-25]\\d|3[1-689])\\d{4,8}|4[1-8]\\d{4}|6[0-8]\\d{3,4}|7[1-7]\\d{5,8})|497[0-7]\\d{4}|49(?:[0-2579]\\d|[34][1-9])\\d{3}|[1-9]\\d{5}|[13468]\\d{4}',
            [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
            [
              ['(\\d{2})(\\d{3,13})', '$1 $2', ['3[02]|40|[68]9'], '0$1'],
              [
                '(\\d{3})(\\d{3,12})',
                '$1 $2',
                [
                  '2(?:0[1-389]|1[124]|2[18]|3[14]|[4-9]1)|3(?:[35-9][15]|4[015])|(?:4[2-9]|[57][1-9]|[68][1-8])1|9(?:06|[1-9]1)',
                  '2(?:0[1-389]|1(?:[14]|2[0-8])|2[18]|3[14]|[4-9]1)|3(?:[35-9][15]|4[015])|(?:4[2-9]|[57][1-9]|[68][1-8])1|9(?:06|[1-9]1)',
                ],
                '0$1',
              ],
              ['(\\d{3})(\\d{4})', '$1 $2', ['138'], '0$1'],
              [
                '(\\d{4})(\\d{3,11})',
                '$1 $2',
                [
                  '[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|7(?:0[2-8]|[1-9])|8(?:0[2-9]|[1-8])|9(?:0[7-9]|[1-9])',
                  '[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|[49][1246]|6[1-4]|7[13468]|8[13568])|6(?:0[1356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|7(?:0[2-8]|[1-9])|8(?:0[2-9]|[1-8])|9(?:0[7-9]|[1-9])',
                ],
                '0$1',
              ],
              ['(\\d{3})(\\d{5,11})', '$1 $2', ['181'], '0$1'],
              ['(\\d{3})(\\d)(\\d{4,10})', '$1 $2 $3', ['1(?:3|80)|9'], '0$1'],
              ['(\\d{5})(\\d{3,10})', '$1 $2', ['3'], '0$1'],
              ['(\\d{3})(\\d{7,8})', '$1 $2', ['1(?:6[02-489]|7)'], '0$1'],
              ['(\\d{3})(\\d{7,12})', '$1 $2', ['8'], '0$1'],
              ['(\\d{4})(\\d{7})', '$1 $2', ['15[1279]'], '0$1'],
              ['(\\d{5})(\\d{6})', '$1 $2', ['15[0568]'], '0$1'],
              ['(\\d{3})(\\d{4})(\\d{4})', '$1 $2 $3', ['7'], '0$1'],
              [
                '(\\d{3})(\\d{8})',
                '$1 $2',
                ['18[2-579]', '18[2-579]', '18(?:[2-479]|5(?:0[1-9]|[1-9]))'],
                '0$1',
              ],
              ['(\\d{4})(\\d{7})', '$1 $2', ['18[68]'], '0$1'],
              ['(\\d{5})(\\d{6})', '$1 $2', ['18'], '0$1'],
              ['(\\d{3})(\\d{2})(\\d{7,8})', '$1 $2 $3', ['1(?:6[023]|7)'], '0$1'],
              ['(\\d{3})(\\d{2})(\\d{8})', '$1 $2 $3', ['15[013-68]'], '0$1'],
              ['(\\d{4})(\\d{2})(\\d{7})', '$1 $2 $3', ['15'], '0$1'],
            ],
            '0',
          ],
          DJ: [
            '253',
            '00',
            '(?:2\\d|77)\\d{6}',
            [8],
            [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[27]']]],
          ],
          DK: [
            '45',
            '00',
            '[2-9]\\d{7}',
            [8],
            [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[2-9]']]],
          ],
          DM: ['1', '011', '(?:[58]\\d\\d|767|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '767'],
          DO: ['1', '011', '(?:[58]\\d\\d|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '8[024]9'],
          DZ: [
            '213',
            '00',
            '(?:[1-4]|[5-79]\\d|80)\\d{7}',
            [8, 9],
            [
              ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[1-4]'], '0$1'],
              ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[5-8]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['9'], '0$1'],
            ],
            '0',
          ],
          EC: [
            '593',
            '00',
            '1800\\d{6,7}|(?:[2-7]|9\\d)\\d{7}',
            [8, 9, 10, 11],
            [
              ['(\\d)(\\d{3})(\\d{4})', '$1 $2-$3', ['[2-7]'], '(0$1)', 0, '$1-$2-$3'],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['9'], '0$1'],
              ['(\\d{4})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['1']],
            ],
            '0',
          ],
          EE: [
            '372',
            '00',
            '8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d\\d|900)\\d{4}',
            [7, 8, 10],
            [
              [
                '(\\d{3})(\\d{4})',
                '$1 $2',
                [
                  '[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]',
                  '[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]',
                ],
              ],
              ['(\\d{4})(\\d{3,4})', '$1 $2', ['[45]|8(?:00|[1-4])', '[45]|8(?:00[1-9]|[1-4])']],
              ['(\\d{2})(\\d{2})(\\d{4})', '$1 $2 $3', ['7']],
              ['(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3', ['80']],
            ],
          ],
          EG: [
            '20',
            '00',
            '(?:[189]\\d?|[24-6])\\d{8}|[13]\\d{7}',
            [8, 9, 10],
            [
              ['(\\d)(\\d{7,8})', '$1 $2', ['[23]'], '0$1'],
              ['(\\d{2})(\\d{6,7})', '$1 $2', ['1[35]|[4-6]|8[2468]|9[235-7]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['[189]'], '0$1'],
            ],
            '0',
          ],
          EH: ['212', '00', '[5-8]\\d{8}', [9], 0, '0', 0, 0, 0, 0, '528[89]'],
          ER: [
            '291',
            '00',
            '[178]\\d{6}',
            [7],
            [['(\\d)(\\d{3})(\\d{3})', '$1 $2 $3', ['[178]'], '0$1']],
            '0',
          ],
          ES: [
            '34',
            '00',
            '(?:51|[6-9]\\d)\\d{7}',
            [9],
            [
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[89]00']],
              [
                '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                '$1 $2 $3 $4',
                ['[568]|7[0-48]|9(?:0[12]|[1-8])'],
              ],
            ],
          ],
          ET: [
            '251',
            '00',
            '(?:11|[2-59]\\d)\\d{7}',
            [9],
            [['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[1-59]'], '0$1']],
            '0',
          ],
          FI: [
            '358',
            '00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))',
            '(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}|[1-35689]\\d{4}',
            [5, 6, 7, 8, 9, 10],
            [
              ['(\\d)(\\d{4,9})', '$1 $2', ['[2568][1-8]|3(?:0[1-9]|[1-9])|9'], '0$1'],
              [
                '(\\d{2})(\\d{4,8})',
                '$1 $2',
                ['1(?:0[1-9]|[3-79][1-8]|8)|2(?:0[1-9]|9)|[45]|7[135]'],
                '0$1',
              ],
              ['(\\d{3})(\\d{3,7})', '$1 $2', ['(?:1|20)0|[36-8]'], '0$1'],
            ],
            '0',
            0,
            0,
            0,
            0,
            '1[03-79]|[2-9]',
            0,
            '00',
          ],
          FJ: [
            '679',
            '0(?:0|52)',
            '(?:(?:0800\\d|[235-9])\\d|45)\\d{5}',
            [7, 11],
            [
              ['(\\d{3})(\\d{4})', '$1 $2', ['[235-9]|45']],
              ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['0']],
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            '00',
          ],
          FK: ['500', '00', '[2-7]\\d{4}', [5]],
          FM: [
            '691',
            '00',
            '[39]\\d{6}',
            [7],
            [['(\\d{3})(\\d{4})', '$1 $2', ['3(?:20|[357])|9', '3(?:20[1-9]|[357])|9']]],
          ],
          FO: [
            '298',
            '00',
            '(?:[2-8]\\d|90)\\d{4}',
            [6],
            [['(\\d{6})', '$1', ['[2-9]']]],
            0,
            0,
            '(10(?:01|[12]0|88))',
          ],
          FR: [
            '33',
            '00',
            '[1-9]\\d{8}',
            [9],
            [
              ['(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4 $5', ['[1-79]'], '0$1'],
              ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['8'], '0 $1'],
            ],
            '0',
          ],
          GA: [
            '241',
            '00',
            '(?:0\\d|[2-7])\\d{6}',
            [7, 8],
            [
              ['(\\d)(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[2-7]'], '0$1'],
              ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['0']],
            ],
          ],
          GB: [
            '44',
            '00',
            '[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}',
            [7, 9, 10],
            [
              ['(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3', ['845', '8454', '84546', '845464'], '0$1'],
              ['(\\d{3})(\\d{4})', '$1 $2', ['800', '8001', '80011', '800111', '8001111'], '0$1'],
              ['(\\d{3})(\\d{6})', '$1 $2', ['800'], '0$1'],
              [
                '(\\d{4})(\\d{5,6})',
                '$1 $2',
                [
                  '1(?:[2-79][02-9]|8)',
                  '1(?:[24][02-9]|3(?:[02-79]|8[0-46-9])|5(?:[04-9]|2[024-9]|3[014-689])|6(?:[02-8]|9[0-24578])|7(?:[02-57-9]|6[013-9])|8|9(?:[0235-9]|4[2-9]))',
                  '1(?:[24][02-9]|3(?:[02-79]|8(?:[0-4689]|7[0-24-9]))|5(?:[04-9]|2(?:[025-9]|4[013-9])|3(?:[014-68]|9[0-37-9]))|6(?:[02-8]|9(?:[0-2458]|7[0-25689]))|7(?:[02-57-9]|6(?:[013-79]|8[0-25689]))|8|9(?:[0235-9]|4(?:[2-57-9]|6[0-689])))',
                ],
                '0$1',
              ],
              ['(\\d{5})(\\d{4,5})', '$1 $2', ['1(?:38|5[23]|69|7|94)'], '0$1'],
              [
                '(\\d{2})(\\d{4})(\\d{4})',
                '$1 $2 $3',
                ['[25]|7(?:0|6[024-9])', '[25]|7(?:0|6(?:[04-9]|2[356]))'],
                '0$1',
              ],
              ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['[1389]'], '0$1'],
              ['(\\d{4})(\\d{6})', '$1 $2', ['7'], '0$1'],
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
              [
                '(?:1(?:1(?:3[0-58]|4[0-5]|5[0-26-9]|6[0-4]|[78][0-49])|2(?:0[024-9]|1[0-7]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)|3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))|2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d)\\d{6}|1(?:(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d|7(?:(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))\\d|6888[2-46-8]))\\d\\d',
                [9, 10],
              ],
              [
                '7(?:(?:[1-3]\\d\\d|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|8(?:[014-9]\\d|[23][0-8]))\\d|4(?:[0-46-9]\\d\\d|5(?:[0-689]\\d|7[0-57-9]))|7(?:0(?:0[01]|[1-9]\\d)|(?:[1-7]\\d|8[02-9]|9[0-689])\\d)|9(?:(?:[024-9]\\d|3[0-689])\\d|1(?:[02-9]\\d|1[028])))\\d{5}',
                [10],
              ],
              ['80[08]\\d{7}|800\\d{6}|8001111'],
              ['(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d', [7, 10]],
              ['70\\d{8}', [10]],
              0,
              ['(?:3[0347]|55)\\d{8}', [10]],
              ['76(?:0[0-2]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}', [10]],
              ['56\\d{8}', [10]],
            ],
            0,
            ' x',
          ],
          GD: ['1', '011', '(?:473|[58]\\d\\d|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '473'],
          GE: [
            '995',
            '00',
            '(?:[3-57]\\d\\d|800)\\d{6}',
            [9],
            [
              ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[348]'], '0$1'],
              ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['5|79']],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['7'], '0$1'],
            ],
            '0',
          ],
          GF: [
            '594',
            '00',
            '[56]94\\d{6}',
            [9],
            [['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[56]'], '0$1']],
            '0',
          ],
          GG: [
            '44',
            '00',
            '(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?',
            [7, 9, 10],
            0,
            '0',
            0,
            '0|([25-9]\\d{5})$',
            '1481$1',
            0,
            0,
            [
              ['1481[25-9]\\d{5}', [10]],
              ['7(?:(?:781|839)\\d|911[17])\\d{5}', [10]],
              ['80[08]\\d{7}|800\\d{6}|8001111'],
              ['(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d', [7, 10]],
              ['70\\d{8}', [10]],
              0,
              ['(?:3[0347]|55)\\d{8}', [10]],
              ['76(?:0[0-2]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}', [10]],
              ['56\\d{8}', [10]],
            ],
          ],
          GH: [
            '233',
            '00',
            '(?:[235]\\d{3}|800)\\d{5}',
            [8, 9],
            [
              ['(\\d{3})(\\d{5})', '$1 $2', ['8'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[235]'], '0$1'],
            ],
            '0',
          ],
          GI: [
            '350',
            '00',
            '(?:[25]\\d\\d|629)\\d{5}',
            [8],
            [['(\\d{3})(\\d{5})', '$1 $2', ['2']]],
          ],
          GL: [
            '299',
            '00',
            '(?:19|[2-689]\\d)\\d{4}',
            [6],
            [['(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3', ['19|[2-689]']]],
          ],
          GM: ['220', '00', '[2-9]\\d{6}', [7], [['(\\d{3})(\\d{4})', '$1 $2', ['[2-9]']]]],
          GN: [
            '224',
            '00',
            '(?:30|6\\d\\d|722)\\d{6}',
            [8, 9],
            [
              ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['3']],
              ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[67]']],
            ],
          ],
          GP: [
            '590',
            '00',
            '(?:590|69\\d)\\d{6}',
            [9],
            [['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[56]'], '0$1']],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
              [
                '590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}',
              ],
              ['69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}'],
            ],
          ],
          GQ: [
            '240',
            '00',
            '(?:222|(?:3\\d|55|[89]0)\\d)\\d{6}',
            [9],
            [
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[235]']],
              ['(\\d{3})(\\d{6})', '$1 $2', ['[89]']],
            ],
          ],
          GR: [
            '30',
            '00',
            '(?:[268]\\d|[79]0)\\d{8}',
            [10],
            [
              ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2 $3', ['21|7']],
              ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['2[3-8]1|[689]']],
              ['(\\d{4})(\\d{6})', '$1 $2', ['2']],
            ],
          ],
          GT: [
            '502',
            '00',
            '(?:1\\d{3}|[2-7])\\d{7}',
            [8, 11],
            [
              ['(\\d{4})(\\d{4})', '$1 $2', ['[2-7]']],
              ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['1']],
            ],
          ],
          GU: ['1', '011', '(?:[58]\\d\\d|671|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '671'],
          GW: [
            '245',
            '00',
            '[49]\\d{8}|4\\d{6}',
            [7, 9],
            [
              ['(\\d{3})(\\d{4})', '$1 $2', ['40']],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[49]']],
            ],
          ],
          GY: [
            '592',
            '001',
            '(?:(?:(?:[2-46]\\d|77)\\d|862)\\d|9008)\\d{3}',
            [7],
            [['(\\d{3})(\\d{4})', '$1 $2', ['[2-46-9]']]],
          ],
          HK: [
            '852',
            '00(?:30|5[09]|[126-9]?)',
            '8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}',
            [5, 6, 7, 8, 9, 11],
            [
              ['(\\d{3})(\\d{2,5})', '$1 $2', ['900', '9003']],
              ['(\\d{4})(\\d{4})', '$1 $2', ['[2-7]|8[1-4]|9(?:0[1-9]|[1-8])']],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['8']],
              ['(\\d{3})(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['9']],
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            '00',
          ],
          HN: ['504', '00', '[237-9]\\d{7}', [8], [['(\\d{4})(\\d{4})', '$1-$2', ['[237-9]']]]],
          HR: [
            '385',
            '00',
            '(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}',
            [6, 7, 8, 9],
            [
              ['(\\d{2})(\\d{2})(\\d{2,3})', '$1 $2 $3', ['6[01]'], '0$1'],
              ['(\\d{3})(\\d{2})(\\d{2,3})', '$1 $2 $3', ['8'], '0$1'],
              ['(\\d)(\\d{4})(\\d{3})', '$1 $2 $3', ['1'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[2-5]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[67]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['9'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['8'], '0$1'],
            ],
            '0',
          ],
          HT: [
            '509',
            '00',
            '[2-489]\\d{7}',
            [8],
            [['(\\d{2})(\\d{2})(\\d{4})', '$1 $2 $3', ['[2-489]']]],
          ],
          HU: [
            '36',
            '00',
            '[2357]\\d{8}|[1-9]\\d{7}',
            [8, 9],
            [
              ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['1'], '($1)'],
              ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[2-9]'], '($1)'],
            ],
            '06',
          ],
          ID: [
            '62',
            '0(?:0[17-9]|10(?:00|1[67]))',
            '(?:[1-36]|8\\d{5})\\d{6}|[1-9]\\d{8,10}|[2-9]\\d{7}',
            [7, 8, 9, 10, 11, 12],
            [
              ['(\\d)(\\d{3})(\\d{3})', '$1 $2 $3', ['15']],
              ['(\\d{2})(\\d{5,8})', '$1 $2', ['2[124]|[36]1'], '(0$1)'],
              ['(\\d{3})(\\d{5,7})', '$1 $2', ['800'], '0$1'],
              ['(\\d{3})(\\d{5,8})', '$1 $2', ['[2-579]|6[2-5]'], '(0$1)'],
              ['(\\d{3})(\\d{3,4})(\\d{3})', '$1-$2-$3', ['8[1-35-9]'], '0$1'],
              ['(\\d{3})(\\d{6,8})', '$1 $2', ['1'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['804'], '0$1'],
              ['(\\d{3})(\\d)(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['80'], '0$1'],
              ['(\\d{3})(\\d{4})(\\d{4,5})', '$1-$2-$3', ['8'], '0$1'],
            ],
            '0',
          ],
          IE: [
            '353',
            '00',
            '[148]\\d{9}|[124-9]\\d{8}|[124-69]\\d{7}|[24-69]\\d{6}',
            [7, 8, 9, 10],
            [
              ['(\\d{2})(\\d{5})', '$1 $2', ['2[24-9]|47|58|6[237-9]|9[35-9]'], '(0$1)'],
              ['(\\d{3})(\\d{5})', '$1 $2', ['[45]0'], '(0$1)'],
              ['(\\d)(\\d{3,4})(\\d{4})', '$1 $2 $3', ['1'], '(0$1)'],
              ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[2569]|4[1-69]|7[14]'], '(0$1)'],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['76|8[235-9]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['7'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['81'], '(0$1)'],
              ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2 $3', ['4'], '(0$1)'],
              ['(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3', ['1']],
              ['(\\d{2})(\\d)(\\d{3})(\\d{4})', '$1 $2 $3 $4', ['8'], '0$1'],
            ],
            '0',
          ],
          IL: [
            '972',
            '0(?:0|1[2-9])',
            '1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}',
            [7, 8, 9, 10, 11, 12],
            [
              ['(\\d{4})(\\d{3})', '$1-$2', ['125']],
              ['(\\d)(\\d{3})(\\d{4})', '$1-$2-$3', ['[2-489]'], '0$1'],
              ['(\\d{4})(\\d{2})(\\d{2})', '$1-$2-$3', ['121']],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1-$2-$3', ['[57]'], '0$1'],
              ['(\\d{4})(\\d{3})(\\d{3})', '$1-$2-$3', ['12']],
              ['(\\d{4})(\\d{6})', '$1-$2', ['159']],
              ['(\\d)(\\d{3})(\\d{3})(\\d{3})', '$1-$2-$3-$4', ['1[7-9]']],
              ['(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})', '$1-$2 $3-$4', ['1']],
            ],
            '0',
          ],
          IM: [
            '44',
            '00',
            '(?:1624|(?:[3578]\\d|90)\\d\\d)\\d{6}',
            [10],
            0,
            '0',
            0,
            '0|([5-8]\\d{5})$',
            '1624$1',
            0,
            0,
            [
              ['1624[5-8]\\d{5}'],
              ['7(?:4576|[59]24\\d|624[0-4689])\\d{5}'],
              ['808162\\d{4}'],
              ['(?:8(?:4(?:40[49]06|5624\\d)|7(?:0624|2299)\\d)|90[0167]624\\d)\\d{3}'],
              ['70\\d{8}'],
              0,
              ['(?:3(?:(?:08162|3\\d{4}|7(?:0624|2299))\\d|4(?:40[49]06|5624\\d))|55\\d{5})\\d{3}'],
              0,
              ['56\\d{8}'],
            ],
          ],
          IN: [
            '91',
            '00',
            '(?:00800|1\\d{0,5}|[2-9]\\d\\d)\\d{7}',
            [8, 9, 10, 11, 12, 13],
            [
              ['(\\d{8})', '$1', ['5[0236-8]']],
              ['(\\d{4})(\\d{4,5})', '$1 $2', ['180', '1800']],
              [
                '(\\d{2})(\\d{4})(\\d{4})',
                '$1 $2 $3',
                [
                  '11|2[02]|33|4[04]|79[1-7]|80[2-46]',
                  '11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])',
                  '11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])',
                ],
                '0$1',
              ],
              [
                '(\\d{3})(\\d{3})(\\d{4})',
                '$1 $2 $3',
                [
                  '1(?:2[0-249]|3[0-25]|4[145]|[59][14]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1|9[15])|6(?:12|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)',
                  '1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6(?:0[2-7]|[1-9])|7[1257]|8(?:[06][2-7]|[1-57-9]))|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5(?:1|2[2-7])|[78]1|9[15])|6(?:12[2-7]|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|(?:2[14]|5[15])[2-6]|3(?:1[2-7]|[34][2-6])|4[47][2-7]|61[346]|88[0-8])|8(?:(?:16|2[014]|3[126]|6[136])[2-7]|7(?:0[2-6]|[78][2-7])|8(?:3[2-7]|4[235-7])|91[3-7])',
                  '1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6(?:0[2-7]|[1-9])|7[1257]|8(?:[06][2-7]|[1-57-9]))|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5(?:1|2[2-7])|[78]1|9[15])|6(?:12(?:[2-6]|7[0-8])|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|(?:2[14]|5[15])[2-6]|3(?:1(?:[2-6]|71)|[34][2-6])|4[47](?:[2-6]|7[19])|61[346]|88(?:[01][2-7]|[2-7]|82))|8(?:(?:16|2[014]|3[126]|6[136])(?:[2-6]|7[19])|7(?:0[2-6]|[78](?:[2-6]|7[19]))|8(?:3(?:[2-6]|7[19])|4(?:[2356]|7[19]))|91(?:[3-6]|7[19]))',
                ],
                '0$1',
              ],
              [
                '(\\d{4})(\\d{3})(\\d{3})',
                '$1 $2 $3',
                [
                  '1(?:[23579]|4[236-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|[4-8])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807',
                  '1(?:[23579]|4[236-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|[4-8])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]',
                  '1(?:[23579]|4[236-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|[4-8])|7(?:1(?:[013-8]|9[6-9])|(?:28[6-8]|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7])[2-7]|3(?:179|(?:2[0-49]|9[2-57])[2-7]))|807(?:1|9[1-3])',
                ],
                '0$1',
              ],
              ['(\\d{5})(\\d{5})', '$1 $2', ['[6-9]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['14']],
              ['(\\d{4})(\\d{2,4})(\\d{4})', '$1 $2 $3', ['180', '1800']],
              ['(\\d{4})(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['1']],
            ],
            '0',
            0,
            0,
            0,
            1,
          ],
          IO: ['246', '00', '3\\d{6}', [7], [['(\\d{3})(\\d{4})', '$1 $2', ['3']]]],
          IQ: [
            '964',
            '00',
            '(?:1|[2-6]\\d?|7\\d\\d)\\d{7}',
            [8, 9, 10],
            [
              ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['1'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[2-6]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['7'], '0$1'],
            ],
            '0',
          ],
          IR: [
            '98',
            '00',
            '[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}',
            [4, 5, 6, 7, 10],
            [
              ['(\\d{4,5})', '$1', ['96'], '0$1'],
              [
                '(\\d{2})(\\d{4,5})',
                '$1 $2',
                ['(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]'],
                '0$1',
              ],
              ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['9'], '0$1'],
              ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2 $3', ['[1-8]'], '0$1'],
            ],
            '0',
          ],
          IS: [
            '354',
            '00|1(?:0(?:01|[12]0)|100)',
            '(?:38\\d|[4-9])\\d{6}',
            [7, 9],
            [
              ['(\\d{3})(\\d{4})', '$1 $2', ['[4-9]']],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['3']],
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            '00',
          ],
          IT: [
            '39',
            '00',
            '0\\d{6}(?:\\d{4})?|3[0-8]\\d{9}|(?:[0138]\\d?|55)\\d{8}|[08]\\d{5}(?:\\d{2})?',
            [6, 7, 8, 9, 10, 11],
            [
              ['(\\d{2})(\\d{4,6})', '$1 $2', ['0[26]']],
              [
                '(\\d{3})(\\d{3,6})',
                '$1 $2',
                [
                  '0[13-57-9][0159]|8(?:03|4[17]|9[245])',
                  '0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))',
                ],
              ],
              ['(\\d{4})(\\d{2,6})', '$1 $2', ['0(?:[13-579][2-46-8]|8[236-8])']],
              ['(\\d{4})(\\d{4})', '$1 $2', ['894']],
              ['(\\d{2})(\\d{3,4})(\\d{4})', '$1 $2 $3', ['0[26]|5']],
              ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['1(?:44|[67]|99)|[38]']],
              ['(\\d{3})(\\d{3,4})(\\d{4})', '$1 $2 $3', ['0[13-57-9][0159]']],
              ['(\\d{3})(\\d{4})(\\d{4})', '$1 $2 $3', ['3']],
              ['(\\d{2})(\\d{4})(\\d{5})', '$1 $2 $3', ['0[26]']],
              ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['0']],
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
              [
                '0(?:(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d|6(?:[0-57-9]\\d\\d|6(?:[0-8]\\d|9[0-79])))\\d{1,6}',
              ],
              ['33\\d{9}|3[1-9]\\d{8}|3[2-9]\\d{7}', [9, 10, 11]],
              ['80(?:0\\d{3}|3)\\d{3}', [6, 9]],
              [
                '(?:(?:0878|1(?:44|6[346])\\d)\\d\\d|89(?:2|(?:4[5-9]|(?:5[5-9]|9)\\d\\d)\\d))\\d{3}|89[45][0-4]\\d\\d',
                [6, 8, 9, 10],
              ],
              ['1(?:78\\d|99)\\d{6}', [9, 10]],
              0,
              0,
              0,
              ['55\\d{8}', [10]],
              ['84(?:[08]\\d{3}|[17])\\d{3}', [6, 9]],
            ],
          ],
          JE: [
            '44',
            '00',
            '(?:1534|(?:[3578]\\d|90)\\d\\d)\\d{6}',
            [10],
            0,
            '0',
            0,
            '0|([0-24-8]\\d{5})$',
            '1534$1',
            0,
            0,
            [
              ['1534[0-24-8]\\d{5}'],
              ['7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}'],
              ['80(?:07(?:35|81)|8901)\\d{4}'],
              [
                '(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}',
              ],
              ['701511\\d{4}'],
              0,
              [
                '(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}',
              ],
              ['76(?:0[0-2]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}'],
              ['56\\d{8}'],
            ],
          ],
          JM: ['1', '011', '(?:[58]\\d\\d|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '876'],
          JO: [
            '962',
            '00',
            '(?:(?:(?:[268]|7\\d)\\d|32|53)\\d|900)\\d{5}',
            [8, 9],
            [
              ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['[2356]|87'], '(0$1)'],
              ['(\\d{3})(\\d{5,6})', '$1 $2', ['[89]'], '0$1'],
              ['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['7[457-9]'], '0$1'],
              ['(\\d{2})(\\d{7})', '$1 $2', ['7'], '0$1'],
            ],
            '0',
          ],
          JP: [
            '81',
            '010',
            '00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}',
            [8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
            [
              ['(\\d{3})(\\d{3})(\\d{3})', '$1-$2-$3', ['(?:12|57|99)0'], '0$1'],
              [
                '(\\d{4})(\\d)(\\d{4})',
                '$1-$2-$3',
                [
                  '1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])',
                  '1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))',
                  '1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[2-57-9])|9(?:496|802|9(?:1[23]|69))',
                ],
                '0$1',
              ],
              [
                '(\\d{3})(\\d{2})(\\d{4})',
                '$1-$2-$3',
                [
                  '1(?:[2-46]|5[2-8]|7[2-689]|8[2-7]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|[67]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])',
                  '1(?:[2-46]|5(?:[236-8]|[45][2-69])|7[2-689]|8[2-7]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|[67]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:[3-6][2-9]|7[2-6]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|4[2-69]|[5-7]))',
                  '1(?:[2-46]|5(?:[236-8]|[45][2-69])|7[2-689]|8[2-7]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|[67]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6[56]))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))',
                  '1(?:[2-46]|5(?:[236-8]|[45][2-69])|7[2-689]|8[2-7]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|[67]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6(?:5[25]|60)))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))',
                ],
                '0$1',
              ],
              [
                '(\\d{2})(\\d{3})(\\d{4})',
                '$1-$2-$3',
                [
                  '1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93)',
                  '1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])',
                  '1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])',
                ],
                '0$1',
              ],
              [
                '(\\d{3})(\\d{2})(\\d{4})',
                '$1-$2-$3',
                ['2(?:[34]7|[56]9|74|9[14-79])|82|993'],
                '0$1',
              ],
              ['(\\d)(\\d{4})(\\d{4})', '$1-$2-$3', ['[36]|4(?:2[09]|7[01])'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1-$2-$3', ['2[2-9]|4|7[235-9]|9[49]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{4})', '$1-$2-$3', ['800'], '0$1'],
              ['(\\d{2})(\\d{4})(\\d{4})', '$1-$2-$3', ['[2579]|80'], '0$1'],
            ],
            '0',
          ],
          KE: [
            '254',
            '000',
            '(?:(?:2|80)0\\d?|[4-7]\\d\\d|900)\\d{6}|[4-6]\\d{6,7}',
            [7, 8, 9, 10],
            [
              ['(\\d{2})(\\d{5,7})', '$1 $2', ['[24-6]'], '0$1'],
              ['(\\d{3})(\\d{6})', '$1 $2', ['7'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[89]'], '0$1'],
            ],
            '0',
          ],
          KG: [
            '996',
            '00',
            '(?:[235-7]\\d|99)\\d{7}|800\\d{6,7}',
            [9, 10],
            [
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[25-79]|31[25]'], '0$1'],
              ['(\\d{4})(\\d{5})', '$1 $2', ['3'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d)(\\d{2,3})', '$1 $2 $3 $4', ['8'], '0$1'],
            ],
            '0',
          ],
          KH: [
            '855',
            '00[14-9]',
            '1\\d{9}|[1-9]\\d{7,8}',
            [8, 9, 10],
            [
              ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[1-9]'], '0$1'],
              ['(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3', ['1']],
            ],
            '0',
          ],
          KI: [
            '686',
            '00',
            '(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}',
            [5, 8],
            0,
            '0',
            0,
            0,
            0,
            1,
          ],
          KM: [
            '269',
            '00',
            '[3478]\\d{6}',
            [7],
            [['(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3', ['[3478]']]],
          ],
          KN: ['1', '011', '(?:[58]\\d\\d|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '869'],
          KP: [
            '850',
            '00|99',
            '(?:(?:19\\d|2)\\d|85)\\d{6}',
            [8, 10],
            [
              ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['2'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['8'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['1'], '0$1'],
            ],
            '0',
          ],
          KR: [
            '82',
            '00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))',
            '(?:00[1-9]\\d{2,4}|[12]|5\\d{3})\\d{7}|(?:(?:00|[13-6])\\d|70)\\d{8}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}',
            [5, 6, 8, 9, 10, 11, 12, 13, 14],
            [
              ['(\\d{2})(\\d{3,4})', '$1-$2', ['(?:3[1-3]|[46][1-4]|5[1-5])1']],
              [
                '(\\d{4})(\\d{4})',
                '$1-$2',
                [
                  '1(?:5[246-9]|6[046-8]|8[03579])',
                  '1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))',
                ],
                '$1',
              ],
              ['(\\d{5})', '$1', ['1[016-9]1', '1[016-9]11', '1[016-9]114']],
              ['(\\d)(\\d{3,4})(\\d{4})', '$1-$2-$3', ['2[1-9]']],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1-$2-$3', ['60[2-9]|80']],
              [
                '(\\d{2})(\\d{3,4})(\\d{4})',
                '$1-$2-$3',
                ['1[0-25-9]|(?:3[1-3]|[46][1-4]|5[1-5])[1-9]'],
              ],
              ['(\\d{2})(\\d{4})(\\d{4})', '$1-$2-$3', ['[57]0']],
              ['(\\d{2})(\\d{5})(\\d{4})', '$1-$2-$3', ['50']],
            ],
            '0',
            '0$1',
            '0(8[1-46-8]|85\\d{2})?',
          ],
          KW: [
            '965',
            '00',
            '(?:18|[2569]\\d\\d)\\d{5}',
            [7, 8],
            [
              ['(\\d{4})(\\d{3,4})', '$1 $2', ['[169]|2(?:[235]|4[1-35-9])|52']],
              ['(\\d{3})(\\d{5})', '$1 $2', ['[25]']],
            ],
          ],
          KY: ['1', '011', '(?:345|[58]\\d\\d|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '345'],
          KZ: [
            '7',
            '810',
            '(?:33622|(?:7\\d|80)\\d{3})\\d{5}',
            [10],
            0,
            '8',
            0,
            0,
            0,
            0,
            '33|7',
            0,
            '8~10',
          ],
          LA: [
            '856',
            '00',
            '(?:2\\d|3)\\d{8}|(?:[235-8]\\d|41)\\d{6}',
            [8, 9, 10],
            [
              ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['2[13]|3[14]|[4-8]'], '0$1'],
              ['(\\d{2})(\\d{2})(\\d{2})(\\d{3})', '$1 $2 $3 $4', ['3'], '0$1'],
              ['(\\d{2})(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['2'], '0$1'],
            ],
            '0',
          ],
          LB: [
            '961',
            '00',
            '[7-9]\\d{7}|[13-9]\\d{6}',
            [7, 8],
            [
              [
                '(\\d)(\\d{3})(\\d{3})',
                '$1 $2 $3',
                ['[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]'],
                '0$1',
              ],
              ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['[7-9]']],
            ],
            '0',
          ],
          LC: ['1', '011', '(?:[58]\\d\\d|758|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '758'],
          LI: [
            '423',
            '00',
            '(?:(?:[2378]|6\\d\\d)\\d|90)\\d{5}',
            [7, 9],
            [
              ['(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3', ['[237-9]']],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['6[56]']],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['6']],
            ],
            '0',
            0,
            '0|(10(?:01|20|66))',
          ],
          LK: [
            '94',
            '00',
            '(?:[1-7]\\d|[89]1)\\d{7}',
            [9],
            [
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[1-689]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['7'], '0$1'],
            ],
            '0',
          ],
          LR: [
            '231',
            '00',
            '(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[45])\\d{6}',
            [7, 8, 9],
            [
              ['(\\d)(\\d{3})(\\d{3})', '$1 $2 $3', ['[45]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['2'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[23578]'], '0$1'],
            ],
            '0',
          ],
          LS: [
            '266',
            '00',
            '(?:[256]\\d\\d|800)\\d{5}',
            [8],
            [['(\\d{4})(\\d{4})', '$1 $2', ['[2568]']]],
          ],
          LT: [
            '370',
            '00',
            '(?:[3469]\\d|52|[78]0)\\d{6}',
            [8],
            [
              ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['52[0-79]'], '(8-$1)'],
              ['(\\d{2})(\\d{6})', '$1 $2', ['37|4(?:[15]|6[1-8])'], '(8-$1)'],
              ['(\\d{3})(\\d{5})', '$1 $2', ['[3-6]'], '(8-$1)'],
              ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['[7-9]'], '8 $1'],
            ],
            '8',
            0,
            '[08]',
            0,
            1,
          ],
          LU: [
            '352',
            '00',
            '[2457-9]\\d{3,10}|3(?:[0-46-9]\\d{2,9}|5(?:[013-9]\\d{1,8}|2\\d{1,3}))|6\\d{8}',
            [4, 5, 6, 7, 8, 9, 10, 11],
            [
              [
                '(\\d{2})(\\d{3})',
                '$1 $2',
                [
                  '2(?:0[2-689]|[2-9])|3(?:[0-46-9]|5[013-9])|[457]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])',
                ],
              ],
              [
                '(\\d{2})(\\d{2})(\\d{2})',
                '$1 $2 $3',
                [
                  '2(?:0[2-689]|[2-9])|3(?:[0-46-9]|5[013-9])|[457]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])',
                ],
              ],
              ['(\\d{2})(\\d{2})(\\d{3})', '$1 $2 $3', ['20[2-689]']],
              ['(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})', '$1 $2 $3 $4', ['2(?:0[1-689]|[367]|4[3-8])']],
              ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['80[01]|90[015]']],
              ['(\\d{2})(\\d{2})(\\d{2})(\\d{3})', '$1 $2 $3 $4', ['20[2-689]']],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['6']],
              [
                '(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})',
                '$1 $2 $3 $4 $5',
                ['2(?:0[2-689]|[367]|4[3-8])'],
              ],
              [
                '(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})',
                '$1 $2 $3 $4',
                ['2[2-9]|3(?:[0-46-9]|5[013-9])|[457]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])'],
              ],
            ],
            0,
            0,
            '(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)',
          ],
          LV: [
            '371',
            '00',
            '(?:[268]\\d|90)\\d{6}',
            [8],
            [['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['[269]|8[01]']]],
          ],
          LY: [
            '218',
            '00',
            '(?:[2569]\\d|71)\\d{7}',
            [9],
            [['(\\d{2})(\\d{7})', '$1-$2', ['[25-79]'], '0$1']],
            '0',
          ],
          MA: [
            '212',
            '00',
            '[5-8]\\d{8}',
            [9],
            [
              ['(\\d{3})(\\d{6})', '$1-$2', ['5(?:2[015-7]|3[0-4])|[67]'], '0$1'],
              [
                '(\\d{4})(\\d{5})',
                '$1-$2',
                ['5(?:2[2-489]|3[5-9]|9)|892', '5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|9)|892'],
                '0$1',
              ],
              ['(\\d{5})(\\d{4})', '$1-$2', ['5[23]'], '0$1'],
              ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['5'], '0$1'],
              ['(\\d{2})(\\d{7})', '$1-$2', ['8'], '0$1'],
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
              [
                '5(?:2(?:[015-79]\\d|2[02-9]|3[2-57]|4[2-8]|8[235-7])|3(?:[0-48]\\d|[57][2-9]|6[2-8]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}',
              ],
              ['(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[067]|6[1267]|7[017]))\\d{6}'],
              ['80\\d{7}'],
              ['89\\d{7}'],
              0,
              0,
              0,
              0,
              ['5924[01]\\d{4}'],
            ],
          ],
          MC: [
            '377',
            '00',
            '(?:(?:[349]|6\\d)\\d\\d|870)\\d{5}',
            [8, 9],
            [
              ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[39]']],
              ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['4'], '0$1'],
              ['(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4 $5', ['6'], '0$1'],
            ],
            '0',
          ],
          MD: [
            '373',
            '00',
            '(?:[235-7]\\d|[89]0)\\d{6}',
            [8],
            [
              ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['22|3'], '0$1'],
              ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['[25-7]'], '0$1'],
              ['(\\d{3})(\\d{5})', '$1 $2', ['[89]'], '0$1'],
            ],
            '0',
          ],
          ME: [
            '382',
            '00',
            '(?:20|[3-79]\\d|80\\d?)\\d{6}',
            [8, 9],
            [['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[2-9]'], '0$1']],
            '0',
          ],
          MF: [
            '590',
            '00',
            '(?:590|69\\d)\\d{6}',
            [9],
            0,
            '0',
            0,
            0,
            0,
            0,
            0,
            [
              ['590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}'],
              ['69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}'],
            ],
          ],
          MG: [
            '261',
            '00',
            '[23]\\d{8}',
            [9],
            [['([23]\\d)(\\d{2})(\\d{3})(\\d{2})', '$1 $2 $3 $4', ['[23]']]],
            '0',
            '0$1',
          ],
          MH: [
            '692',
            '011',
            '(?:(?:[256]\\d|45)\\d|329)\\d{4}',
            [7],
            [['(\\d{3})(\\d{4})', '$1-$2', ['[2-6]']]],
            '1',
          ],
          MK: [
            '389',
            '00',
            '[2-578]\\d{7}',
            [8],
            [
              ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['2'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['[347]'], '0$1'],
              ['(\\d{3})(\\d)(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[58]'], '0$1'],
            ],
            '0',
          ],
          ML: [
            '223',
            '00',
            '(?:[246-9]\\d|50)\\d{6}',
            [8],
            [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[24-79]|8[0239]']]],
          ],
          MM: [
            '95',
            '00',
            '(?:1|[24-7]\\d)\\d{5,7}|8\\d{6,9}|9(?:[0-46-9]\\d{6,8}|5\\d{6})|2\\d{5}',
            [6, 7, 8, 9, 10],
            [
              ['(\\d)(\\d{2})(\\d{3})', '$1 $2 $3', ['16|2'], '0$1'],
              [
                '(\\d{2})(\\d{2})(\\d{3})',
                '$1 $2 $3',
                ['[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]'],
                '0$1',
              ],
              ['(\\d)(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[12]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[4-7]|8[1-35]'], '0$1'],
              ['(\\d)(\\d{3})(\\d{4,6})', '$1 $2 $3', ['9(?:2[0-4]|[35-9]|4[137-9])'], '0$1'],
              ['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['2'], '0$1'],
              ['(\\d)(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['92'], '0$1'],
              ['(\\d)(\\d{5})(\\d{4})', '$1 $2 $3', ['9'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['8'], '0$1'],
            ],
            '0',
          ],
          MN: [
            '976',
            '001',
            '[12]\\d{8,9}|[1257-9]\\d{7}',
            [8, 9, 10],
            [
              ['(\\d{2})(\\d{2})(\\d{4})', '$1 $2 $3', ['[12]1'], '0$1'],
              ['(\\d{4})(\\d{4})', '$1 $2', ['[57-9]']],
              ['(\\d{3})(\\d{5,6})', '$1 $2', ['[12]2[1-3]'], '0$1'],
              [
                '(\\d{4})(\\d{5,6})',
                '$1 $2',
                ['[12](?:27|3[2-8]|4[2-68]|5[1-4689])', '[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]'],
                '0$1',
              ],
              ['(\\d{5})(\\d{4,5})', '$1 $2', ['[12]'], '0$1'],
            ],
            '0',
          ],
          MO: [
            '853',
            '00',
            '(?:28|[68]\\d)\\d{6}',
            [8],
            [['(\\d{4})(\\d{4})', '$1 $2', ['[268]']]],
          ],
          MP: ['1', '011', '(?:[58]\\d\\d|(?:67|90)0)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '670'],
          MQ: [
            '596',
            '00',
            '(?:596|69\\d)\\d{6}',
            [9],
            [['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[56]'], '0$1']],
            '0',
          ],
          MR: [
            '222',
            '00',
            '(?:[2-4]\\d\\d|800)\\d{5}',
            [8],
            [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[2-48]']]],
          ],
          MS: [
            '1',
            '011',
            '(?:(?:[58]\\d\\d|900)\\d\\d|66449)\\d{5}',
            [10],
            0,
            '1',
            0,
            0,
            0,
            0,
            '664',
          ],
          MT: [
            '356',
            '00',
            '(?:(?:[2579]\\d\\d|800)\\d|3550)\\d{4}',
            [8],
            [['(\\d{4})(\\d{4})', '$1 $2', ['[2357-9]']]],
          ],
          MU: [
            '230',
            '0(?:0|[24-7]0|3[03])',
            '(?:[2-468]|5\\d)\\d{6}',
            [7, 8],
            [
              ['(\\d{3})(\\d{4})', '$1 $2', ['[2-46]|8(?:0[0-2]|14|3[129])']],
              ['(\\d{4})(\\d{4})', '$1 $2', ['5']],
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            '020',
          ],
          MV: [
            '960',
            '0(?:0|19)',
            '(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}',
            [7, 10],
            [
              ['(\\d{3})(\\d{4})', '$1-$2', ['[367]|4(?:00|[56])|9[14-9]']],
              ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['[89]']],
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            '00',
          ],
          MW: [
            '265',
            '00',
            '1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}',
            [7, 9],
            [
              ['(\\d)(\\d{3})(\\d{3})', '$1 $2 $3', ['1[2-9]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['2'], '0$1'],
              ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[17-9]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['3'], '0$1'],
            ],
            '0',
          ],
          MX: [
            '52',
            '0[09]',
            '(?:1\\d|[2-9])\\d{9}',
            [10, 11],
            [
              ['([358]\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['33|55|81']],
              [
                '(\\d{3})(\\d{3})(\\d{4})',
                '$1 $2 $3',
                ['[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]'],
              ],
              [
                '(1)([358]\\d)(\\d{4})(\\d{4})',
                '044 $2 $3 $4',
                ['1(?:33|55|81)'],
                '$1',
                0,
                '$1 $2 $3 $4',
              ],
              [
                '(1)(\\d{3})(\\d{3})(\\d{4})',
                '044 $2 $3 $4',
                ['1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])'],
                '$1',
                0,
                '$1 $2 $3 $4',
              ],
            ],
            '01',
            '01 $1',
            '0[12]|04[45](\\d{10})',
            '1$1',
            1,
          ],
          MY: [
            '60',
            '00',
            '(?:1\\d\\d?|3\\d|[4-9])\\d{7}',
            [8, 9, 10],
            [
              ['(\\d)(\\d{3})(\\d{4})', '$1-$2 $3', ['[4-79]'], '0$1'],
              [
                '(\\d{2})(\\d{3})(\\d{3,4})',
                '$1-$2 $3',
                ['1(?:[0249]|[367][2-9]|8[1-9])|8'],
                '0$1',
              ],
              ['(\\d)(\\d{4})(\\d{4})', '$1-$2 $3', ['3'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{4})', '$1-$2 $3', ['15'], '0$1'],
              ['(\\d{2})(\\d{4})(\\d{4})', '$1-$2 $3', ['11'], '0$1'],
              ['(\\d)(\\d{3})(\\d{2})(\\d{4})', '$1-$2-$3-$4', ['1']],
            ],
            '0',
          ],
          MZ: [
            '258',
            '00',
            '(?:2|8\\d)\\d{7}',
            [8, 9],
            [
              ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['2|8[2-7]']],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['8']],
            ],
          ],
          NA: [
            '264',
            '00',
            '[68]\\d{7,8}',
            [8, 9],
            [
              ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['88'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['6'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['8[0-5]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['8'], '0$1'],
            ],
            '0',
          ],
          NC: [
            '687',
            '00',
            '[2-57-9]\\d{5}',
            [6],
            [['(\\d{2})(\\d{2})(\\d{2})', '$1.$2.$3', ['[247-9]|3[0-6]|5[0-4]']]],
          ],
          NE: [
            '227',
            '00',
            '[0289]\\d{7}',
            [8],
            [
              ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['09|2[01]|8[04589]|9']],
              ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['0']],
            ],
          ],
          NF: [
            '672',
            '00',
            '[13]\\d{5}',
            [6],
            [
              ['(\\d{2})(\\d{4})', '$1 $2', ['1']],
              ['(\\d)(\\d{5})', '$1 $2', ['3']],
            ],
          ],
          NG: [
            '234',
            '009',
            '[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}',
            [7, 8, 10, 11, 12, 13, 14],
            [
              ['(\\d{2})(\\d{2})(\\d{3})', '$1 $2 $3', ['78'], '0$1'],
              ['(\\d)(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[12]|9(?:0[3-9]|[1-9])'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{2,3})', '$1 $2 $3', ['[3-7]|8[2-9]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[7-9]'], '0$1'],
              ['(\\d{3})(\\d{4})(\\d{4,5})', '$1 $2 $3', ['[78]'], '0$1'],
              ['(\\d{3})(\\d{5})(\\d{5,6})', '$1 $2 $3', ['[78]'], '0$1'],
            ],
            '0',
          ],
          NI: [
            '505',
            '00',
            '(?:1800|[25-8]\\d{3})\\d{4}',
            [8],
            [['(\\d{4})(\\d{4})', '$1 $2', ['[125-8]']]],
          ],
          NL: [
            '31',
            '00',
            '(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8])|[89]\\d{0,3})\\d{6}|1\\d{4,5}',
            [5, 6, 7, 8, 9, 10],
            [
              ['(\\d{3})(\\d{4,7})', '$1 $2', ['[89]0'], '0$1'],
              [
                '(\\d{2})(\\d{3})(\\d{4})',
                '$1 $2 $3',
                ['1[035]|2[0346]|3[03568]|4[0356]|5[0358]|[7-9]'],
                '0$1',
              ],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[1-5]'], '0$1'],
              ['(\\d)(\\d{8})', '$1 $2', ['6[1-58]'], '0$1'],
              ['(\\d{2})(\\d{7})', '$1 $2', ['6'], '0$1'],
            ],
            '0',
          ],
          NO: [
            '47',
            '00',
            '(?:0|[2-9]\\d{3})\\d{4}',
            [5, 8],
            [
              ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[235-7]']],
              ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['[489]']],
            ],
            0,
            0,
            0,
            0,
            0,
            '[02-689]|7[0-8]',
          ],
          NP: [
            '977',
            '00',
            '9\\d{9}|[1-9]\\d{7}',
            [8, 10],
            [
              ['(\\d)(\\d{7})', '$1-$2', ['1[2-6]'], '0$1'],
              ['(\\d{2})(\\d{6})', '$1-$2', ['[1-8]|9(?:[1-579]|6[2-6])'], '0$1'],
              ['(\\d{3})(\\d{7})', '$1-$2', ['9']],
            ],
            '0',
          ],
          NR: [
            '674',
            '00',
            '(?:444|55\\d|888)\\d{4}',
            [7],
            [['(\\d{3})(\\d{4})', '$1 $2', ['[458]']]],
          ],
          NU: [
            '683',
            '00',
            '(?:[47]|888\\d)\\d{3}',
            [4, 7],
            [['(\\d{3})(\\d{4})', '$1 $2', ['8']]],
          ],
          NZ: [
            '64',
            '0(?:0|161)',
            '[28]\\d{7,9}|[346]\\d{7}|(?:508|[79]\\d)\\d{6,7}',
            [8, 9, 10],
            [
              ['(\\d)(\\d{3})(\\d{4})', '$1-$2 $3', ['24|[346]|7[2-57-9]|9[2-9]'], '0$1'],
              ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['80|9'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['2(?:10|74)|[59]|80'], '0$1'],
              ['(\\d{2})(\\d{3,4})(\\d{4})', '$1 $2 $3', ['2[028]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{3,5})', '$1 $2 $3', ['[278]'], '0$1'],
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            0,
            '00',
          ],
          OM: [
            '968',
            '00',
            '(?:[279]\\d{3}|500|8007\\d?)\\d{4}',
            [7, 8, 9],
            [
              ['(\\d{3})(\\d{4,6})', '$1 $2', ['[58]']],
              ['(\\d{2})(\\d{6})', '$1 $2', ['2']],
              ['(\\d{4})(\\d{4})', '$1 $2', ['[79]']],
            ],
          ],
          PA: [
            '507',
            '00',
            '(?:[1-57-9]|6\\d)\\d{6}',
            [7, 8],
            [
              ['(\\d{3})(\\d{4})', '$1-$2', ['[1-57-9]']],
              ['(\\d{4})(\\d{4})', '$1-$2', ['6']],
            ],
          ],
          PE: [
            '51',
            '19(?:1[124]|77|90)00',
            '(?:[14-8]|9\\d)\\d{7}',
            [8, 9],
            [
              ['(\\d)(\\d{7})', '$1 $2', ['1'], '(0$1)'],
              ['(\\d{2})(\\d{6})', '$1 $2', ['[4-7]|8[2-4]'], '(0$1)'],
              ['(\\d{3})(\\d{5})', '$1 $2', ['8'], '(0$1)'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['9']],
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            ' Anexo ',
          ],
          PF: [
            '689',
            '00',
            '[48]\\d{7}|4\\d{5}',
            [6, 8],
            [
              ['(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3', ['44']],
              ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[48]']],
            ],
          ],
          PG: [
            '675',
            '00|140[1-3]',
            '(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}',
            [7, 8],
            [
              ['(\\d{3})(\\d{4})', '$1 $2', ['18|[2-69]|85']],
              ['(\\d{4})(\\d{4})', '$1 $2', ['[78]']],
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            '00',
          ],
          PH: [
            '63',
            '00',
            '(?:1800\\d{2,4}|2|[89]\\d{4})\\d{5}|[3-8]\\d{8}|[28]\\d{7}',
            [6, 8, 9, 10, 11, 12, 13],
            [
              ['(\\d)(\\d{5})', '$1 $2', ['2'], '(0$1)'],
              ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['2'], '(0$1)'],
              [
                '(\\d{4})(\\d{4,6})',
                '$1 $2',
                [
                  '3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])',
                  '3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))',
                ],
                '(0$1)',
              ],
              [
                '(\\d{2})(\\d{3})(\\d{4})',
                '$1 $2 $3',
                [
                  '3[2-68]|4[2-9]|[5-7]|8[2-8]',
                  '3(?:[23568]|4(?:[0-57-9]|6[02-8]))|4(?:2(?:[0-689]|7[0-8])|[3-8]|9(?:[0-246-9]|3[1-9]|5[0-57-9]))|[5-7]|8(?:[2-7]|8(?:[0-24-9]|3[0-35-9]))',
                ],
                '(0$1)',
              ],
              ['(\\d{5})(\\d{4})', '$1 $2', ['[34]|88'], '(0$1)'],
              ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['[89]'], '0$1'],
              ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['1']],
              ['(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})', '$1 $2 $3 $4', ['1']],
            ],
            '0',
          ],
          PK: [
            '92',
            '00',
            '(?:122|[24-8]\\d{4,5}|9(?:[013-9]\\d{2,4}|2(?:[01]\\d\\d|2(?:[025-8]\\d|1[01]))\\d))\\d{6}|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}',
            [8, 9, 10, 11, 12],
            [
              ['(\\d{3})(\\d{3})(\\d{2})', '$1 $2 $3', ['[89]0'], '0$1'],
              ['(\\d{4})(\\d{5})', '$1 $2', ['1']],
              [
                '(\\d{2})(\\d{7,8})',
                '$1 $2',
                ['(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]'],
                '(0$1)',
              ],
              [
                '(\\d{3})(\\d{6,7})',
                '$1 $2',
                [
                  '2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])',
                  '(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356]))[2-9]|9(?:2(?:2[2-9]|[3-8])|(?:3[27-9]|4[2-6]|6[3569])[2-9]|9(?:[25-7][2-9]|8))',
                ],
                '(0$1)',
              ],
              ['(\\d{5})(\\d{5})', '$1 $2', ['58'], '(0$1)'],
              ['(\\d{3})(\\d{7})', '$1 $2', ['3'], '0$1'],
              [
                '(\\d{2})(\\d{3})(\\d{3})(\\d{3})',
                '$1 $2 $3 $4',
                ['2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91'],
                '(0$1)',
              ],
              ['(\\d{3})(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['[24-9]'], '(0$1)'],
            ],
            '0',
          ],
          PL: [
            '48',
            '00',
            '[1-9]\\d{6}(?:\\d{2})?|6\\d{5}(?:\\d{2})?',
            [6, 7, 8, 9],
            [
              ['(\\d{5})', '$1', ['19']],
              ['(\\d{3})(\\d{3})', '$1 $2', ['11|64']],
              [
                '(\\d{2})(\\d{2})(\\d{3})',
                '$1 $2 $3',
                [
                  '(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1',
                  '(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19',
                ],
              ],
              ['(\\d{3})(\\d{2})(\\d{2,3})', '$1 $2 $3', ['64']],
              [
                '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                '$1 $2 $3 $4',
                ['1[2-8]|2|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]'],
              ],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[3-8]']],
            ],
          ],
          PM: [
            '508',
            '00',
            '[45]\\d{5}',
            [6],
            [['(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3', ['[45]'], '0$1']],
            '0',
          ],
          PR: ['1', '011', '(?:[589]\\d\\d|787)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '787|939'],
          PS: [
            '970',
            '00',
            '(?:(?:1\\d|5)\\d\\d|[2489]2)\\d{6}',
            [8, 9, 10],
            [
              ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['[2489]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['5'], '0$1'],
              ['(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3', ['1']],
            ],
            '0',
          ],
          PT: [
            '351',
            '00',
            '(?:[26-9]\\d|30)\\d{7}',
            [9],
            [
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['2[12]']],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[236-9]']],
            ],
          ],
          PW: [
            '680',
            '01[12]',
            '(?:[25-8]\\d\\d|345|488|900)\\d{4}',
            [7],
            [['(\\d{3})(\\d{4})', '$1 $2', ['[2-9]']]],
          ],
          PY: [
            '595',
            '00',
            '(?:[2-46-9]\\d|5[0-8])\\d{7}|[2-9]\\d{5,7}',
            [6, 7, 8, 9],
            [
              ['(\\d{3})(\\d{3,6})', '$1 $2', ['[2-9]0'], '0$1'],
              ['(\\d{2})(\\d{5})', '$1 $2', ['[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]'], '(0$1)'],
              [
                '(\\d{3})(\\d{4,5})',
                '$1 $2',
                ['2[279]|3[13-5]|4[359]|5|6[347]|7[46-8]|85'],
                '(0$1)',
              ],
              [
                '(\\d{2})(\\d{3})(\\d{3,4})',
                '$1 $2 $3',
                ['[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]'],
                '(0$1)',
              ],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[2-7]|85'], '0$1'],
              ['(\\d{3})(\\d{6})', '$1 $2', ['9'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['8']],
            ],
            '0',
          ],
          QA: [
            '974',
            '00',
            '(?:(?:2|[3-7]\\d)\\d\\d|800)\\d{4}',
            [7, 8],
            [
              ['(\\d{3})(\\d{4})', '$1 $2', ['2[126]|8']],
              ['(\\d{4})(\\d{4})', '$1 $2', ['[3-7]']],
            ],
          ],
          RE: [
            '262',
            '00',
            '(?:26|[68]\\d)\\d{7}',
            [9],
            [['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[268]'], '0$1']],
            '0',
            0,
            0,
            0,
            0,
            '262|69|8',
          ],
          RO: [
            '40',
            '00',
            '(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}',
            [6, 9],
            [
              ['(\\d{2})(\\d{4})', '$1 $2', ['219|31'], '0$1'],
              ['(\\d{3})(\\d{3})', '$1 $2', ['2[3-6]', '2[3-6]\\d9'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[23]1'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[237-9]'], '0$1'],
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            ' int ',
          ],
          RS: [
            '381',
            '00',
            '[127]\\d{6,11}|3(?:[0-79]\\d{5,10}|8(?:[02-9]\\d{4,9}|1\\d{4,5}))|6\\d{7,9}|800\\d{3,9}|90\\d{4,8}|7\\d{5}',
            [6, 7, 8, 9, 10, 11, 12],
            [
              ['(\\d{3})(\\d{3,9})', '$1 $2', ['(?:2[389]|39)0|[7-9]'], '0$1'],
              ['(\\d{2})(\\d{5,10})', '$1 $2', ['[1-36]'], '0$1'],
            ],
            '0',
          ],
          RU: [
            '7',
            '810',
            '[347-9]\\d{9}',
            [10],
            [
              ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['7'], '8 ($1)', 1],
              ['(\\d{3})(\\d{3})(\\d{2})(\\d{2})', '$1 $2-$3-$4', ['[3489]'], '8 ($1)', 1],
            ],
            '8',
            0,
            0,
            0,
            0,
            '3[04-689]|[489]',
            0,
            '8~10',
          ],
          RW: [
            '250',
            '00',
            '(?:06|[27]\\d\\d|[89]00)\\d{6}',
            [8, 9],
            [
              ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['0']],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['2']],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[7-9]'], '0$1'],
            ],
            '0',
          ],
          SA: [
            '966',
            '00',
            '(?:(?:[15]|8\\d)\\d|92)\\d{7}',
            [9, 10],
            [
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['1'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['5'], '0$1'],
              ['(\\d{4})(\\d{5})', '$1 $2', ['9']],
              ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['81'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['8']],
            ],
            '0',
          ],
          SB: [
            '677',
            '0[01]',
            '(?:[1-6]|[7-9]\\d\\d)\\d{4}',
            [5, 7],
            [
              [
                '(\\d{2})(\\d{5})',
                '$1 $2',
                [
                  '7[1-9]|8[4-9]|9(?:1[2-9]|2[013-9]|3[0-2]|[46]|5[0-46-9]|7[0-689]|8[0-79]|9[0-8])',
                ],
              ],
            ],
          ],
          SC: [
            '248',
            '0(?:[02]|10?)',
            '(?:(?:(?:[24]\\d|64)\\d|971)\\d|8000)\\d{3}',
            [7],
            [['(\\d)(\\d{3})(\\d{3})', '$1 $2 $3', ['[246]']]],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            '00',
          ],
          SD: [
            '249',
            '00',
            '[19]\\d{8}',
            [9],
            [['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[19]'], '0$1']],
            '0',
          ],
          SE: [
            '46',
            '00',
            '(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}',
            [6, 7, 8, 9, 10],
            [
              ['(\\d{2})(\\d{2,3})(\\d{2})', '$1-$2 $3', ['20'], '0$1', 0, '$1 $2 $3'],
              [
                '(\\d{2})(\\d{3})(\\d{2})',
                '$1-$2 $3',
                ['[12][136]|3[356]|4[0246]|6[03]|90[1-9]'],
                '0$1',
                0,
                '$1 $2 $3',
              ],
              ['(\\d{3})(\\d{4})', '$1-$2', ['9(?:00|39|44)'], '0$1', 0, '$1 $2'],
              ['(\\d)(\\d{2,3})(\\d{2})(\\d{2})', '$1-$2 $3 $4', ['8'], '0$1', 0, '$1 $2 $3 $4'],
              [
                '(\\d{3})(\\d{2,3})(\\d{2})',
                '$1-$2 $3',
                [
                  '1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])',
                ],
                '0$1',
                0,
                '$1 $2 $3',
              ],
              [
                '(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})',
                '$1-$2 $3 $4',
                ['1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]'],
                '0$1',
                0,
                '$1 $2 $3 $4',
              ],
              ['(\\d{3})(\\d{2,3})(\\d{3})', '$1-$2 $3', ['9(?:0|39|44)'], '0$1', 0, '$1 $2 $3'],
              ['(\\d)(\\d{3})(\\d{3})(\\d{2})', '$1-$2 $3 $4', ['8'], '0$1', 0, '$1 $2 $3 $4'],
              [
                '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                '$1-$2 $3 $4',
                ['[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])'],
                '0$1',
                0,
                '$1 $2 $3 $4',
              ],
              ['(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1-$2 $3 $4', ['7'], '0$1', 0, '$1 $2 $3 $4'],
              ['(\\d{3})(\\d{2})(\\d{2})(\\d{3})', '$1-$2 $3 $4', ['9'], '0$1', 0, '$1 $2 $3 $4'],
              [
                '(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                '$1-$2 $3 $4 $5',
                ['[26]'],
                '0$1',
                0,
                '$1 $2 $3 $4 $5',
              ],
            ],
            '0',
          ],
          SG: [
            '65',
            '0[0-3]\\d',
            '(?:1\\d{3}|[369]|7000|8(?:\\d{2})?)\\d{7}',
            [8, 10, 11],
            [
              ['(\\d{4})(\\d{4})', '$1 $2', ['[369]|8[1-8]']],
              ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['8']],
              ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['1[89]']],
              ['(\\d{4})(\\d{4})(\\d{3})', '$1 $2 $3', ['70']],
            ],
          ],
          SH: ['290', '00', '(?:[256]\\d|8)\\d{3}', [4, 5], 0, 0, 0, 0, 0, 0, '[256]'],
          SI: [
            '386',
            '00',
            '[1-8]\\d{7}|90\\d{4,6}|8\\d{4,6}',
            [5, 6, 7, 8],
            [
              ['(\\d{2})(\\d{3,6})', '$1 $2', ['8[09]|9'], '0$1'],
              [
                '(\\d)(\\d{3})(\\d{2})(\\d{2})',
                '$1 $2 $3 $4',
                ['[12]|[34][24-8]|5[2-8]|7[3-8]'],
                '(0$1)',
              ],
              ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['[3467]|51'], '0$1'],
              ['(\\d{3})(\\d{5})', '$1 $2', ['[58]'], '0$1'],
            ],
            '0',
          ],
          SJ: ['47', '00', '(?:0|(?:[4589]\\d|79)\\d\\d)\\d{4}', [5, 8], 0, 0, 0, 0, 0, 0, '79'],
          SK: [
            '421',
            '00',
            '[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}',
            [6, 7, 9],
            [
              ['(\\d)(\\d{2})(\\d{3,4})', '$1 $2 $3', ['21'], '0$1'],
              ['(\\d{2})(\\d{2})(\\d{2,3})', '$1 $2 $3', ['[3-5][1-8]1', '[3-5][1-8]1[67]'], '0$1'],
              ['(\\d)(\\d{3})(\\d{3})(\\d{2})', '$1/$2 $3 $4', ['2'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1/$2 $3 $4', ['[3-5]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[689]'], '0$1'],
            ],
            '0',
          ],
          SL: [
            '232',
            '00',
            '(?:[2-578]\\d|66|99)\\d{6}',
            [8],
            [['(\\d{2})(\\d{6})', '$1 $2', ['[2-9]'], '(0$1)']],
            '0',
          ],
          SM: [
            '378',
            '00',
            '(?:0549|[5-7]\\d)\\d{6}',
            [8, 10],
            [
              ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[5-7]']],
              ['(\\d{4})(\\d{6})', '$1 $2', ['0']],
            ],
            0,
            0,
            '([89]\\d{5})$',
            '0549$1',
          ],
          SN: [
            '221',
            '00',
            '(?:[378]\\d{4}|93330)\\d{4}',
            [9],
            [
              ['(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[379]']],
              ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['8']],
            ],
          ],
          SO: [
            '252',
            '00',
            '[346-9]\\d{8}|[12679]\\d{7}|(?:[1-4]\\d|59)\\d{5}|[1348]\\d{5}',
            [6, 7, 8, 9],
            [
              ['(\\d{2})(\\d{4})', '$1 $2', ['8[125]']],
              ['(\\d{6})', '$1', ['[134]']],
              ['(\\d)(\\d{6})', '$1 $2', ['[15]|2[0-79]|3[0-46-8]|4[0-7]']],
              ['(\\d)(\\d{7})', '$1 $2', ['24|[67]']],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[348]|64|79[0-8]|90']],
              ['(\\d{2})(\\d{5,7})', '$1 $2', ['[12679]']],
            ],
            '0',
          ],
          SR: [
            '597',
            '00',
            '(?:[2-5]|68|[78]\\d)\\d{5}',
            [6, 7],
            [
              ['(\\d{3})(\\d{3})', '$1-$2', ['[2-4]|5[2-58]']],
              ['(\\d{2})(\\d{2})(\\d{2})', '$1-$2-$3', ['5']],
              ['(\\d{3})(\\d{4})', '$1-$2', ['[6-8]']],
            ],
          ],
          SS: [
            '211',
            '00',
            '[19]\\d{8}',
            [9],
            [['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[19]'], '0$1']],
            '0',
          ],
          ST: ['239', '00', '(?:22|9\\d)\\d{5}', [7], [['(\\d{3})(\\d{4})', '$1 $2', ['[29]']]]],
          SV: [
            '503',
            '00',
            '[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?',
            [7, 8, 11],
            [
              ['(\\d{3})(\\d{4})', '$1 $2', ['[89]']],
              ['(\\d{4})(\\d{4})', '$1 $2', ['[267]']],
              ['(\\d{3})(\\d{4})(\\d{4})', '$1 $2 $3', ['[89]']],
            ],
          ],
          SX: ['1', '011', '(?:(?:[58]\\d\\d|900)\\d|7215)\\d{6}', [10], 0, '1', 0, 0, 0, 0, '721'],
          SY: [
            '963',
            '00',
            '[1-39]\\d{8}|[1-5]\\d{7}',
            [8, 9],
            [
              ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[1-5]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['9'], '0$1'],
            ],
            '0',
            0,
            0,
            0,
            1,
          ],
          SZ: [
            '268',
            '00',
            '(?:0800|(?:[237]\\d|900)\\d\\d)\\d{4}',
            [8, 9],
            [
              ['(\\d{4})(\\d{4})', '$1 $2', ['[0237]']],
              ['(\\d{5})(\\d{4})', '$1 $2', ['9']],
            ],
          ],
          TA: ['290', '00', '8\\d{3}', [4], 0, 0, 0, 0, 0, 0, '8'],
          TC: ['1', '011', '(?:[58]\\d\\d|649|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '649'],
          TD: [
            '235',
            '00|16',
            '(?:22|[69]\\d|77)\\d{6}',
            [8],
            [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[2679]']]],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            '00',
          ],
          TG: [
            '228',
            '00',
            '[279]\\d{7}',
            [8],
            [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[279]']]],
          ],
          TH: [
            '66',
            '00[1-9]',
            '(?:1\\d\\d?|[2-57]|[689]\\d)\\d{7}',
            [8, 9, 10],
            [
              ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['2'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['14|[3-9]'], '0$1'],
              ['(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3', ['1']],
            ],
            '0',
          ],
          TJ: [
            '992',
            '810',
            '(?:[3-59]\\d|77|88)\\d{7}',
            [9],
            [
              [
                '(\\d{4})(\\d)(\\d{4})',
                '$1 $2 $3',
                ['3(?:[1245]|3[12])', '3(?:[1245]|3(?:1[0-689]|2))'],
              ],
              ['(\\d{6})(\\d)(\\d{2})', '$1 $2 $3', ['33']],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['4[148]|[578]|9(?:[0235-9]|1[0-69])']],
              ['(\\d{3})(\\d{2})(\\d{4})', '$1 $2 $3', ['[349]']],
            ],
            '8',
            0,
            0,
            0,
            1,
            0,
            0,
            '8~10',
          ],
          TK: ['690', '00', '[2-47]\\d{3,6}', [4, 5, 6, 7]],
          TL: [
            '670',
            '00',
            '(?:[2-4]\\d|7\\d\\d?|[89]0)\\d{5}',
            [7, 8],
            [
              ['(\\d{3})(\\d{4})', '$1 $2', ['[2-489]|70']],
              ['(\\d{4})(\\d{4})', '$1 $2', ['7']],
            ],
          ],
          TM: [
            '993',
            '810',
            '[1-6]\\d{7}',
            [8],
            [
              ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2-$3-$4', ['12'], '(8 $1)'],
              ['(\\d{2})(\\d{6})', '$1 $2', ['6'], '8 $1'],
              ['(\\d{3})(\\d)(\\d{2})(\\d{2})', '$1 $2-$3-$4', ['[1-5]'], '(8 $1)'],
            ],
            '8',
            0,
            0,
            0,
            0,
            0,
            0,
            '8~10',
          ],
          TN: [
            '216',
            '00',
            '[2-57-9]\\d{7}',
            [8],
            [['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['[2-57-9]']]],
          ],
          TO: [
            '676',
            '00',
            '(?:(?:080|[56])0|[2-4]\\d|[78]\\d(?:\\d{2})?)\\d{3}',
            [5, 7],
            [
              ['(\\d{2})(\\d{3})', '$1-$2', ['[2-6]|7[014]|8[05]']],
              ['(\\d{3})(\\d{4})', '$1 $2', ['7[578]|8']],
              ['(\\d{4})(\\d{3})', '$1 $2', ['0']],
            ],
          ],
          TR: [
            '90',
            '00',
            '(?:[2-58]\\d\\d|900)\\d{7}|4\\d{6}',
            [7, 10],
            [
              ['(\\d{3})(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[2-4]'], '(0$1)'],
              ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['512|[89]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['5'], '0$1'],
            ],
            '0',
            0,
            0,
            0,
            1,
          ],
          TT: ['1', '011', '(?:[58]\\d\\d|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '868'],
          TV: ['688', '00', '(?:2|7\\d\\d|90)\\d{4}', [5, 6, 7]],
          TW: [
            '886',
            '0(?:0[25-79]|19)',
            '(?:[24589]|7\\d)\\d{8}|[2-8]\\d{7}|2\\d{6}',
            [7, 8, 9, 10],
            [
              ['(\\d{2})(\\d)(\\d{4})', '$1 $2 $3', ['202'], '0$1'],
              ['(\\d)(\\d{3,4})(\\d{4})', '$1 $2 $3', ['[25][2-8]|[346]|7[1-9]|8[27-9]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[258]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['9'], '0$1'],
              ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2 $3', ['7'], '0$1'],
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            '#',
          ],
          TZ: [
            '255',
            '00[056]',
            '(?:[26-8]\\d|41|90)\\d{7}',
            [9],
            [
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[24]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[67]'], '0$1'],
              ['(\\d{3})(\\d{2})(\\d{4})', '$1 $2 $3', ['[89]'], '0$1'],
            ],
            '0',
          ],
          UA: [
            '380',
            '00',
            '[3-9]\\d{8}',
            [9],
            [
              [
                '(\\d{3})(\\d{3})(\\d{3})',
                '$1 $2 $3',
                [
                  '(?:3[1-8]|4[136-8])2|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|[89]0',
                  '3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|[89]0',
                ],
                '0$1',
              ],
              [
                '(\\d{4})(\\d{5})',
                '$1 $2',
                [
                  '3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6[12459]',
                  '3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6[12459]',
                ],
                '0$1',
              ],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[35-9]|4(?:[45]|87)'], '0$1'],
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            0,
            '0~0',
          ],
          UG: [
            '256',
            '00[057]',
            '(?:(?:[29]0|[347]\\d)\\d|800)\\d{6}',
            [9],
            [
              ['(\\d{2})(\\d{7})', '$1 $2', ['3|4(?:[0-5]|6[0-36-9])'], '0$1'],
              ['(\\d{4})(\\d{5})', '$1 $2', ['202', '2024'], '0$1'],
              ['(\\d{3})(\\d{6})', '$1 $2', ['[247-9]'], '0$1'],
            ],
            '0',
          ],
          US: [
            '1',
            '011',
            '[2-9]\\d{9}',
            [10],
            [['(\\d{3})(\\d{3})(\\d{4})', '($1) $2-$3', ['[2-9]'], 0, 1, '$1-$2-$3']],
            '1',
            0,
            0,
            0,
            0,
            0,
            [
              [
                '(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[017]|6[0-279]|78|8[0-2])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-28]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}',
              ],
              [''],
              ['8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'],
              ['900[2-9]\\d{6}'],
              ['5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}'],
              0,
              ['710[2-9]\\d{6}'],
            ],
          ],
          UY: [
            '598',
            '0(?:0|1[3-9]\\d)',
            '(?:[249]\\d\\d|80)\\d{5}|9\\d{6}',
            [7, 8],
            [
              ['(\\d{3})(\\d{4})', '$1 $2', ['8|90'], '0$1'],
              ['(\\d{4})(\\d{4})', '$1 $2', ['[24]']],
              ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['9'], '0$1'],
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            0,
            '00',
            ' int. ',
          ],
          UZ: [
            '998',
            '810',
            '[679]\\d{8}',
            [9],
            [['(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[679]'], '8 $1']],
            '8',
            0,
            0,
            0,
            0,
            0,
            0,
            '8~10',
          ],
          VA: [
            '39',
            '00',
            '0\\d{6}(?:\\d{4})?|3[0-8]\\d{9}|(?:[0138]\\d?|55)\\d{8}|[08]\\d{5}(?:\\d{2})?',
            [6, 7, 8, 9, 10, 11],
            0,
            0,
            0,
            0,
            0,
            0,
            '06698',
          ],
          VC: ['1', '011', '(?:[58]\\d\\d|784|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '784'],
          VE: [
            '58',
            '00',
            '(?:(?:[24]\\d|50)\\d|[89]00)\\d{7}',
            [10],
            [['(\\d{3})(\\d{7})', '$1-$2', ['[24589]'], '0$1']],
            '0',
          ],
          VG: ['1', '011', '(?:284|[58]\\d\\d|900)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '284'],
          VI: ['1', '011', '(?:(?:34|90)0|[58]\\d\\d)\\d{7}', [10], 0, '1', 0, 0, 0, 0, '340'],
          VN: [
            '84',
            '00',
            '[12]\\d{9}|[135-9]\\d{8}|(?:[16]\\d?|[78])\\d{6}',
            [7, 8, 9, 10],
            [
              ['(\\d{2})(\\d{5})', '$1 $2', ['80'], '0$1'],
              ['(\\d{4})(\\d{4,6})', '$1 $2', ['1']],
              ['(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[69]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[3578]'], '0$1'],
              ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2 $3', ['2[48]'], '0$1'],
              ['(\\d{3})(\\d{4})(\\d{3})', '$1 $2 $3', ['2'], '0$1'],
            ],
            '0',
            0,
            0,
            0,
            1,
          ],
          VU: [
            '678',
            '00',
            '(?:(?:[23]|(?:[57]\\d|90)\\d)\\d|[48]8)\\d{3}',
            [5, 7],
            [['(\\d{3})(\\d{4})', '$1 $2', ['[579]']]],
          ],
          WF: [
            '681',
            '00',
            '(?:[45]0|68|72|8\\d)\\d{4}',
            [6],
            [['(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3', ['[4-8]']]],
          ],
          WS: [
            '685',
            '0',
            '(?:[2-6]|8\\d(?:\\d{4})?)\\d{4}|[78]\\d{6}',
            [5, 6, 7, 10],
            [
              ['(\\d{5})', '$1', ['[2-6]']],
              ['(\\d{3})(\\d{3,7})', '$1 $2', ['8']],
              ['(\\d{2})(\\d{5})', '$1 $2', ['7']],
            ],
          ],
          XK: [
            '383',
            '00',
            '(?:[23]\\d{2,3}|4\\d\\d|[89]00)\\d{5}',
            [8, 9],
            [
              ['(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3', ['[2-4]'], '0$1'],
              ['(\\d{3})(\\d{5})', '$1 $2', ['[89]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[23]'], '0$1'],
            ],
            '0',
          ],
          YE: [
            '967',
            '00',
            '(?:1|7\\d)\\d{7}|[1-7]\\d{6}',
            [7, 8, 9],
            [
              ['(\\d)(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[1-6]|7[24-68]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['7'], '0$1'],
            ],
            '0',
          ],
          YT: ['262', '00', '(?:(?:26|63)9|80\\d)\\d{6}', [9], 0, '0', 0, 0, 0, 0, '269|63'],
          ZA: [
            '27',
            '00',
            '[1-9]\\d{8}|8\\d{4,7}',
            [5, 6, 7, 8, 9],
            [
              ['(\\d{2})(\\d{3,4})', '$1 $2', ['8[1-4]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{2,3})', '$1 $2 $3', ['8[1-4]'], '0$1'],
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['860'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[1-9]'], '0$1'],
            ],
            '0',
          ],
          ZM: [
            '260',
            '00',
            '(?:(?:21|76|9\\d)\\d|800)\\d{6}',
            [9],
            [
              ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[28]'], '0$1'],
              ['(\\d{2})(\\d{7})', '$1 $2', ['[79]'], '0$1'],
            ],
            '0',
          ],
          ZW: [
            '263',
            '00',
            '2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}',
            [5, 6, 7, 8, 9, 10],
            [
              ['(\\d)(\\d{3})(\\d{2,4})', '$1 $2 $3', ['[49]'], '0$1'],
              [
                '(\\d{3})(\\d{3,5})',
                '$1 $2',
                [
                  '2(?:0[45]|2[278]|[49]8|[78])|3(?:[09]8|17|3[78]|[78])|5[15][78]|6(?:[29]8|37|[68][78]|75)',
                ],
                '0$1',
              ],
              ['(\\d{3})(\\d{4})', '$1 $2', ['80'], '0$1'],
              [
                '(\\d{2})(\\d{7})',
                '$1 $2',
                [
                  '2(?:[05-79]2|4)|(?:39|5[45]|6[15-8])2|8[13-59]',
                  '2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]',
                ],
                '(0$1)',
              ],
              ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['7'], '0$1'],
              [
                '(\\d{3})(\\d{3})(\\d{3,4})',
                '$1 $2 $3',
                [
                  '2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)',
                  '2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)',
                ],
                '0$1',
              ],
              ['(\\d{4})(\\d{6})', '$1 $2', ['8'], '0$1'],
              ['(\\d{2})(\\d{3,5})', '$1 $2', ['[136]|2(?:[0-256]|9[0-79])|5[0-35-9]'], '0$1'],
              ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['29|3|54'], '0$1'],
              ['(\\d{4})(\\d{3,5})', '$1 $2', ['[25]'], '0$1'],
            ],
            '0',
          ],
          '001': ['979', 0, '\\d{9}', [9], [['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3']]],
        },
      };
    },
    function (t, d) {
      t.exports = function (t, d) {
        for (var e = t.split('.'), r = d.split('.'), n = 0; n < 3; n++) {
          var $ = Number(e[n]),
            a = Number(r[n]);
          if ($ > a) return 1;
          if (a > $) return -1;
          if (!isNaN($) && isNaN(a)) return 1;
          if (isNaN($) && !isNaN(a)) return -1;
        }
        return 0;
      };
    },
    function (t, d, e) {
      'use strict';
      Object.defineProperty(d, '__esModule', { value: !0 }),
        (d.DIGIT_PLACEHOLDER =
          d.AsYouTypeCustom =
          d.getCountryCallingCodeCustom =
          d.getNumberTypeCustom =
          d.PhoneNumberSearchCustom =
          d.searchPhoneNumbersCustom =
          d.findPhoneNumbersCustom =
          d.isValidNumberCustom =
          d.formatCustom =
          d.parseCustom =
          d.DIGITS =
          d.parsePhoneNumberCharacter =
          d.parseIncompletePhoneNumber =
          d.Metadata =
            void 0);
      var r = e(1);
      Object.defineProperty(d, 'Metadata', {
        enumerable: !0,
        get: function () {
          return O(r).default;
        },
      });
      var n = e(8);
      Object.defineProperty(d, 'parseIncompletePhoneNumber', {
        enumerable: !0,
        get: function () {
          return O(n).default;
        },
      }),
        Object.defineProperty(d, 'parsePhoneNumberCharacter', {
          enumerable: !0,
          get: function () {
            return n.parsePhoneNumberCharacter;
          },
        }),
        (d.parsePhoneNumber = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), h.default.apply(this, t);
        }),
        (d.parseNumber = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), y.default.apply(this, t);
        }),
        (d.parse = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), y.default.apply(this, t);
        }),
        (d.formatNumber = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), p.default.apply(this, t);
        }),
        (d.format = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), p.default.apply(this, t);
        }),
        (d.getNumberType = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), m.default.apply(this, t);
        }),
        (d.getExampleNumber = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), _.default.apply(this, t);
        }),
        (d.isPossibleNumber = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), v.default.apply(this, t);
        }),
        (d.isValidNumber = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), b.default.apply(this, t);
        }),
        (d.isValidNumberForRegion = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), g.default.apply(this, t);
        }),
        (d.findPhoneNumbers = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), C.default.apply(this, t);
        }),
        (d.searchPhoneNumbers = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), u.searchPhoneNumbers.apply(this, t);
        }),
        (d.PhoneNumberSearch = T),
        (d.findNumbers = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), N.default.apply(this, t);
        }),
        (d.searchNumbers = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), x.default.apply(this, t);
        }),
        (d.PhoneNumberMatcher = R),
        (d.AsYouType = M),
        (d.getExtPrefix = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), r.getExtPrefix.apply(this, t);
        }),
        (d.parseRFC3966 = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), S.parseRFC3966.apply(this, t);
        }),
        (d.formatRFC3966 = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), S.formatRFC3966.apply(this, t);
        }),
        (d.formatIncompletePhoneNumber = function () {
          var t = Array.prototype.slice.call(arguments);
          return t.push(c.default), E.default.apply(this, t);
        });
      var $ = e(0);
      Object.defineProperty(d, 'DIGITS', {
        enumerable: !0,
        get: function () {
          return $.DIGITS;
        },
      });
      var a = e(2);
      Object.defineProperty(d, 'parseCustom', {
        enumerable: !0,
        get: function () {
          return O(a).default;
        },
      });
      var i = e(7);
      Object.defineProperty(d, 'formatCustom', {
        enumerable: !0,
        get: function () {
          return O(i).default;
        },
      });
      var o = e(4);
      Object.defineProperty(d, 'isValidNumberCustom', {
        enumerable: !0,
        get: function () {
          return O(o).default;
        },
      });
      var u = e(10);
      Object.defineProperty(d, 'findPhoneNumbersCustom', {
        enumerable: !0,
        get: function () {
          return O(u).default;
        },
      }),
        Object.defineProperty(d, 'searchPhoneNumbersCustom', {
          enumerable: !0,
          get: function () {
            return u.searchPhoneNumbers;
          },
        }),
        Object.defineProperty(d, 'PhoneNumberSearchCustom', {
          enumerable: !0,
          get: function () {
            return u.PhoneNumberSearch;
          },
        });
      var s = e(3);
      Object.defineProperty(d, 'getNumberTypeCustom', {
        enumerable: !0,
        get: function () {
          return O(s).default;
        },
      });
      var l = e(18);
      Object.defineProperty(d, 'getCountryCallingCodeCustom', {
        enumerable: !0,
        get: function () {
          return O(l).default;
        },
      });
      var f = e(13);
      Object.defineProperty(d, 'AsYouTypeCustom', {
        enumerable: !0,
        get: function () {
          return O(f).default;
        },
      }),
        Object.defineProperty(d, 'DIGIT_PLACEHOLDER', {
          enumerable: !0,
          get: function () {
            return f.DIGIT_PLACEHOLDER;
          },
        }),
        (d.getCountryCallingCode = L),
        (d.getPhoneCode = function (t) {
          return L(t);
        }),
        (d.getPhoneCodeCustom = function (t, d) {
          return (0, I.default)(t, d);
        });
      var c = O(e(27)),
        h = O(e(26)),
        y = O(a),
        p = O(i),
        m = O(s),
        _ = O(e(25)),
        v = O(e(12)),
        b = O(o),
        g = O(e(24)),
        C = O(u),
        N = O(e(23)),
        x = O(e(21)),
        A = O(e(9)),
        P = O(f),
        I = O(l),
        S = e(11),
        E = O(e(20));
      function O(t) {
        return t && t.__esModule ? t : { default: t };
      }
      function T(t, d) {
        u.PhoneNumberSearch.call(this, t, d, c.default);
      }
      function R(t, d) {
        A.default.call(this, t, d, c.default);
      }
      function M(t) {
        P.default.call(this, t, c.default);
      }
      function L(t) {
        return (0, I.default)(t, c.default);
      }
      (T.prototype = Object.create(u.PhoneNumberSearch.prototype, {})),
        (T.prototype.constructor = T),
        (R.prototype = Object.create(A.default.prototype, {})),
        (R.prototype.constructor = R),
        (M.prototype = Object.create(P.default.prototype, {})),
        (M.prototype.constructor = M);
    },
  ]);
});
//# sourceMappingURL=libphonenumber-js.min.js.map
